(() => {
  if (customElements.get('chic-charm-atelier')) return;
  // Photo-bound crops keep complete clasps and pendants while excluding source-photo reflections.
  const preparedCharmPhotos = {
    "celestial-cross-gemstone-pendant": [
        "1775792394685.jpg",
        1024,
        1024,
        "396 92 232 546",
        27
    ],
    "vintage-inspired-multi-stone-gemstone-pendant": [
        "rn-image_picker_lib_temp_dfab696c-c928-43b5-b1ff-6a258d19a0b6.jpg",
        1024,
        1024,
        "398 250 228 388",
        38
    ],
    "tree-of-life-diamond-simulant-pendant-in-18k-gold": [
        "1775793018826.jpg",
        1024,
        1024,
        "342 96 340 609",
        36
    ],
    "puffy-letter-m-initial-pendant": [
        "1775791567374.jpg",
        1024,
        1024,
        "358 160 307 530",
        37
    ],
    "pav-seashell-diamond-simulant-pendant": [
        "1775789972470.jpg",
        1024,
        1024,
        "375 117 273 527",
        33
    ],
    "pav-airplane-diamond-simulant-pendant": [
        "1776028152878.jpg",
        1024,
        1024,
        "341 182 349 640",
        35
    ],
    "tennis-ace-pendant": [
        "rn-image_picker_lib_temp_9c9bcf5a-4f34-42c1-aad5-46eb80f5238e.webp",
        1254,
        1254,
        "460 64 328 954",
        25
    ],
    "golden-puzzle-heart-pendant": [
        "rn-image_picker_lib_temp_9b422951-c80f-491b-9097-5b9ce2d6fea6.webp",
        1254,
        1254,
        "398 140 459 663",
        44
    ],
    "golden-barbell-pendant": [
        "rn-image_picker_lib_temp_cda23023-a613-4583-9f71-a652dc8f9715.webp",
        1254,
        1254,
        "237 152 779 685",
        50
    ],
    "golden-beach-tennis-racket-pendant": [
        "rn-image_picker_lib_temp_5395b4ed-151d-473e-b0b2-54c965ae3766.webp",
        1254,
        1254,
        "459 112 341 940",
        25
    ],
    "sparkling-bow-pave-charm": [
        "rn-image_picker_lib_temp_ad471fcd-d107-4cc3-9712-ff569116c5fd.webp",
        1254,
        1254,
        "348 108 551 771",
        46
    ],
    "golden-love-heart-pendant": [
        "rn-image_picker_lib_temp_b217345d-7f3e-475d-b514-722b01e67732.webp",
        627,
        627,
        "246 55 135 395",
        25
    ],
    "golden-initial-a-pendant": [
        "rn-image_picker_lib_temp_cc00c596-2ab5-4f70-8401-3be6e78c65a6.webp",
        1254,
        1254,
        "468 148 315 790",
        26
    ],
    "golden-initial-b-pendant": [
        "rn-image_picker_lib_temp_b91edb9a-0748-4178-84de-31430455f173.webp",
        1254,
        1254,
        "477 68 339 858",
        25
    ],
    "initial-c-pendant": [
        "rn-image_picker_lib_temp_a2a44c38-3845-4952-b031-377f5147ff58.webp",
        1254,
        1254,
        "466 114 301 826",
        25
    ],
    "initial-d-pendant": [
        "rn-image_picker_lib_temp_19429556-bf4d-4a1b-9fcb-45da2f45a693.webp",
        1254,
        1254,
        "445 99 368 826",
        29
    ],
    "initial-e-pendant": [
        "rn-image_picker_lib_temp_106da5b0-1da9-47c7-8609-f2bcdcc99f83.webp",
        1254,
        1254,
        "475 94 343 801",
        27
    ],
    "initial-f-pendant": [
        "rn-image_picker_lib_temp_6828aabd-5113-4510-a9d3-bc509384411c.webp",
        1254,
        1254,
        "497 169 260 765",
        25
    ],
    "initial-g-pendant": [
        "rn-image_picker_lib_temp_61d27783-0cd2-485e-bf91-885d1ac581c8.webp",
        1254,
        1254,
        "441 115 340 775",
        28
    ],
    "initial-h-pendant": [
        "rn-image_picker_lib_temp_724d4c04-ede0-4d06-bc65-07de3db3d340.webp",
        512,
        512,
        "195 77 122 283",
        28
    ],
    "initial-j-pendant": [
        "rn-image_picker_lib_temp_ca7a5653-8497-4c80-8a92-b4e0c08cf8d9.webp",
        1254,
        1254,
        "473 115 266 834",
        25
    ],
    "initial-k-pendant": [
        "rn-image_picker_lib_temp_a2e7b179-1492-4825-b848-521601544850.webp",
        1254,
        1254,
        "461 181 339 759",
        29
    ],
    "initial-l-pendant": [
        "rn-image_picker_lib_temp_270bdbc5-b0ea-4151-bc98-555a3a614a2c.webp",
        1254,
        1254,
        "505 175 325 750",
        28
    ],
    "initial-p-pendant": [
        "rn-image_picker_lib_temp_baf47a23-5161-48b7-ae98-2c39308b649a.webp",
        1254,
        1254,
        "501 173 254 732",
        25
    ],
    "initial-r-pendant": [
        "rn-image_picker_lib_temp_c94b4177-9d7f-47f0-ab0c-0501b55feaaa.webp",
        1254,
        1254,
        "491 182 287 743",
        25
    ],
    "initial-s-pendant": [
        "rn-image_picker_lib_temp_85e694c6-1988-452c-91e6-9eca57d6a727.webp",
        1254,
        1254,
        "476 179 273 727",
        25
    ],
    "initial-v-pendant": [
        "rn-image_picker_lib_temp_70700419-78d0-4861-9ffa-b06d5ef21366.webp",
        1254,
        1254,
        "505 152 313 786",
        25
    ],
    "initial-t-pendant": [
        "rn-image_picker_lib_temp_330beb40-4349-4afe-a9aa-dde2afb507fa.webp",
        1254,
        1254,
        "462 172 302 744",
        26
    ]
};
  const charmPreviewReferenceWidth = 20;
  const calibratedCharmVisuals = {
    'tree-of-life-diamond-simulant-pendant-in-18k-gold': 1.7,
    'chic-starfish-pav-gemstone-pendant': 1.6,
    'classic-teardrop-pearl-pendant': 1.2,
    'puffy-solid-heart-pendant': 1.6,
    'golden-butterfly-pendant': 1.6,
    'pav-airplane-diamond-simulant-pendant': 1.45,
    'exotic-palm-tree-diamond-simulant-pendant-in-18k-gold-plated-brass': 1.2
  };
  const charmBailAnchors = {
    "celestial-cross-gemstone-pendant": {
      "crop": "396 92 232 546",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.426724,
      "y": 0.1
    },
    "chic-starfish-pav-gemstone-pendant": {
      "crop": "338 90 347 590",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.51585,
      "y": 0.065
    },
    "classic-teardrop-pearl-pendant": {
      "crop": "396 94 234 594",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.578205,
      "y": 0.09
    },
    "evil-eye-coin-gemstone-pendant": {
      "crop": "344 93 336 634",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.44256,
      "y": 0.085
    },
    "exotic-palm-tree-diamond-simulant-pendant-in-18k-gold-plated-brass": {
      "crop": "378 120 268 623",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.380597,
      "y": 0.102729
    },
    "golden-barbell-pendant": {
      "crop": "237 152 779 685",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.498716,
      "y": 0.06
    },
    "golden-beach-tennis-racket-pendant": {
      "crop": "459 112 341 940",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.184164,
      "y": 0.06
    },
    "golden-butterfly-pendant": {
      "crop": "354 149 538 690",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.503532,
      "y": 0.065
    },
    "golden-crescent-moon-pendant": {
      "crop": "480 99 312 862",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.450321,
      "y": 0.065
    },
    "golden-initial-a-pendant": {
      "crop": "468 148 315 790",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.568254,
      "y": 0.09
    },
    "golden-initial-b-pendant": {
      "crop": "477 68 339 858",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.464454,
      "y": 0.08
    },
    "golden-love-heart-pendant": {
      "crop": "246 55 135 395",
      "imageWidth": 627,
      "imageHeight": 627,
      "x": 0.288889,
      "y": 0.085
    },
    "golden-puzzle-heart-pendant": {
      "crop": "398 140 459 663",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.534423,
      "y": 0.085
    },
    "initial-c-pendant": {
      "crop": "466 114 301 826",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.546512,
      "y": 0.06
    },
    "initial-d-pendant": {
      "crop": "445 99 368 826",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.453804,
      "y": 0.085
    },
    "initial-e-pendant": {
      "crop": "475 94 343 801",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.505539,
      "y": 0.08
    },
    "initial-f-pendant": {
      "crop": "497 169 260 765",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.550385,
      "y": 0.085
    },
    "initial-g-pendant": {
      "crop": "441 115 340 775",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.602235,
      "y": 0.08
    },
    "initial-h-pendant": {
      "crop": "195 77 122 283",
      "imageWidth": 512,
      "imageHeight": 512,
      "x": 0.253607,
      "y": 0.085
    },
    "initial-j-pendant": {
      "crop": "473 115 266 834",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.719474,
      "y": 0.08
    },
    "initial-k-pendant": {
      "crop": "461 181 339 759",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.472566,
      "y": 0.08
    },
    "initial-l-pendant": {
      "crop": "505 175 325 750",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.323077,
      "y": 0.085
    },
    "initial-p-pendant": {
      "crop": "501 173 254 732",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.558386,
      "y": 0.08
    },
    "initial-r-pendant": {
      "crop": "491 182 287 743",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.510801,
      "y": 0.08
    },
    "initial-s-pendant": {
      "crop": "476 179 273 727",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.585348,
      "y": 0.08
    },
    "initial-t-pendant": {
      "crop": "462 172 302 744",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.491391,
      "y": 0.08
    },
    "initial-v-pendant": {
      "crop": "505 152 313 786",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.385687,
      "y": 0.08
    },
    "open-heart-pav-diamond-simulant-pendant": {
      "crop": "316 92 392 650",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.496173,
      "y": 0.06
    },
    "pav-airplane-diamond-simulant-pendant": {
      "crop": "341 182 349 640",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.409742,
      "y": 0.103125
    },
    "pav-seashell-diamond-simulant-pendant": {
      "crop": "375 117 273 527",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.387546,
      "y": 0.085
    },
    "puffy-letter-m-initial-pendant": {
      "crop": "358 160 307 530",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.415309,
      "y": 0.085
    },
    "puffy-solid-heart-pendant": {
      "crop": "319 145 388 606",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.494845,
      "y": 0.065
    },
    "sparkling-bow-pave-charm": {
      "crop": "348 108 551 771",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.540472,
      "y": 0.08
    },
    "tennis-ace-pendant": {
      "crop": "460 64 328 954",
      "imageWidth": 1254,
      "imageHeight": 1254,
      "x": 0.39811,
      "y": 0.085
    },
    "tree-of-life-diamond-simulant-pendant-in-18k-gold": {
      "crop": "342 96 340 609",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.430882,
      "y": 0.085
    },
    "vintage-inspired-multi-stone-gemstone-pendant": {
      "crop": "398 250 228 388",
      "imageWidth": 1024,
      "imageHeight": 1024,
      "x": 0.493421,
      "y": 0.075
    }
  };
  const pearlPreviewSilhouette = [
    'M 504 101 C 537 99 553 105 561 132 C 566 157 560 193 556 223 L 553 256 C 552 276 550 286 537 288 L 527 287 C 520 291 504 291 493 283 C 477 273 467 247 462 223 C 458 198 455 165 460 142 C 464 120 478 105 504 101 Z',
    'M 504 281 C 512 282 526 287 527 298 C 529 305 526 310 526 315 C 538 319 543 329 541 340 C 538 353 531 365 523 375 L 499 375 C 489 363 481 346 481 333 C 481 321 489 313 498 310 L 500 291 Z M 500 331 C 506 336 513 337 522 331 C 528 333 527 342 523 348 L 514 361 L 510 361 C 505 352 499 345 496 338 C 495 334 497 332 500 331 Z',
    'M 500 369 C 514 366 531 370 541 378 C 562 392 574 412 585 438 C 598 467 613 494 619 523 C 624 551 619 577 606 599 C 592 622 572 638 547 646 C 532 651 520 651 507 651 C 487 650 466 644 449 633 C 427 619 414 599 409 576 C 401 551 405 522 413 496 C 420 470 432 441 443 416 C 454 391 476 374 500 369 Z',
    'M 499 649 C 507 646 521 647 527 652 C 533 658 533 669 529 677 C 525 685 517 688 509 686 C 498 684 491 677 492 665 C 492 657 495 652 499 649 Z'
  ];
  class ChicCharmAtelier extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-role="config"]').textContent);
      this.config.starterBundles = window.chicAtelierStarterBundles || null;
      this.products = [];
      this.lookup = new Map();
      this.variantChoices = new Map();
      this.deferredGroups = new Map();
      this.variantStates = new Map();
      this.starterMap = new Map();
      this.starterStates = new Map();
      this.configureStarterBundles();
      this.configureBaseCatalog();
      this.baseHandles = new Set((this.usesBaseCatalog() ? this.products : this.config.products).filter(product => product.kind === 'base').map(product => product.handle));
      this.config.products.filter(product => !this.usesBaseCatalog() || product.kind !== 'base').forEach(product => this.mergeProduct(product));
      this.catalogNext = this.config.catalogUrl;
      this.catalogLoading = false;
      this.catalogError = false;
      this.catalogFetched = false;
      this.catalogHandles = new Set();
      this.searchTerm = '';
      this.designTouched = false;
      this.cartQuantities = new Map();
      this.busy = false;
      this.pendingBuild = null;
      this.saved = Object.fromEntries(this.pieces().map(piece => [piece, null]));
      this.storageKey = `chic_atelier_v1:${location.hostname}:${this.config.sectionId}`;
      this.pendingKey = `chic_atelier_pending_v1:${location.hostname}`;
      const initialPiece = this.config.mode === 'pendant' ? 'collar' : this.pieces()[0];
      this.state = { piece: initialPiece, base: '', slots: Array(this.capacity(initialPiece)).fill(null), selected: 0 };
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if (saved && [1, 2].includes(saved.version)) {
          this.rawSaved = saved;
          for (const product of saved.products || []) {
            if (!this.lookup.has(`variant_${product.variantId}`)) this.mergeProduct({ ...product, available: false, needsRefresh: true });
          }
          for (const piece of this.pieces()) this.saved[piece] = this.normalize(saved[piece], piece);
          if (this.saved[initialPiece]) Object.assign(this.state, this.saved[initialPiece]);
        }
      } catch (_) {}
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('change', event => this.onVariantChange(event));
      this.$('search')?.addEventListener('input', event => {
        this.searchTerm = event.target.value.trim().toLocaleLowerCase();
        this.renderCatalog();
        if (this.searchTerm && this.catalogNext) this.loadCatalog(true);
      });
      this.$('base').addEventListener('change', event => {
        if (this.busy) return;
        const previous = this.state.base;
        this.state.base = event.target.value;
        if (this.usesBaseCatalog()) {
          const length = this.capacity(this.state.piece);
          if (this.state.slots.slice(length).some(Boolean)) {
            this.state.base = previous; event.target.value = previous;
            this.notify(this.t('base_capacity_limit', { count: length })); return;
          }
          this.state.slots = Array.from({ length }, (_, index) => this.state.slots[index] || null);
          this.state.selected = Math.min(this.state.selected, length - 1);
        }
        this.designTouched = true;
        this.persist();
        this.render();
      });
      this.$('review-dialog').addEventListener('cancel', event => { if (this.busy) event.preventDefault(); });
      const storedPending = this.storedPending();
      const pendingPiece = storedPending?.items.find(item => ['base', 'starter'].includes(item.properties?._chic_component))?.properties?._chic_piece;
      const unresolved = this.pieces().includes(pendingPiece) ? storedPending : null;
      if (unresolved) {
        this.pendingBuild = unresolved.buildId;
        this.busy = true;
      }
      this.render();
      this.gridClick = event => {
        const control = event.target.closest('[data-atelier-grid-control]');
        if (!control || control.dataset.atelierGridOwner !== this.config.sectionId) return;
        event.stopPropagation();
        const retry = event.target.closest('[data-variant-retry]');
        if (retry) { event.preventDefault(); control.querySelector('[data-option-handle]')?.dispatchEvent(new Event('change', { bubbles: true })); return; }
        const button = event.target.closest('[data-atelier-grid-add]');
        if (button && !button.disabled && !this.busy) {
          event.preventDefault();
          this.addCharm(this.choice(button.dataset.atelierGridAdd)?.key);
        }
      };
      this.gridChange = event => {
        if (event.target.closest('[data-atelier-grid-control]')?.dataset.atelierGridOwner === this.config.sectionId) this.onVariantChange(event);
      };
      document.addEventListener('click', this.gridClick, true);
      document.addEventListener('change', this.gridChange);
      const main = this.closest('main');
      if (main) {
        this.gridObserver = new MutationObserver(mutations => {
          if (mutations.some(mutation => mutation.target.closest?.('.main-featured-product-grid_wrapper'))) this.enhanceGrid();
        });
        this.gridObserver.observe(main, { childList: true, subtree: true });
      }
      this.enhanceGrid();
      if (this.catalogNext) this.loadCatalog(true);
      if (this.usesBaseCatalog()) this.refreshActiveBases().then(() => this.render()).catch(() => {});
      else if (this.designPricingActive()) this.refreshStarterBundles().then(() => this.render()).catch(() => {});
      if (unresolved) this.recoverPending(unresolved);
      else this.readCart().then(cart => { this.updateCartQuantities(cart); this.render(); }).catch(() => {});
    }
    $(role) { return this.querySelector(`[data-role="${role}"]`); }
    usesBaseCatalog() { return this.config.baseCatalogId === 'chic-bases-20261011'; }
    pieces() { return ['necklace', 'bracelet', 'collar']; }
    configureBaseCatalog() {
      this.baseCatalog = new Map();
      if (!this.usesBaseCatalog()) return;
      const source = window.chicAtelierBaseCatalog;
      const rules = { A1: ['bracelet', 6000, 6, true], A2: ['bracelet', 6000, 7, false], N1: ['necklace', 8000, 9, false], N2: ['necklace', 8000, 9, false], N3: ['necklace', 9000, 9, false], N4: ['necklace', 10000, 9, false], C1: ['collar', 8000, 1, false] };
      if (source?.version !== 1 || source.catalogId !== this.config.baseCatalogId || source.currency !== 'USD' || !Array.isArray(source.bases) || source.bases.length !== 7) return;
      const next = new Map(), codes = new Set(), handles = new Set();
      for (const record of source.bases) {
        const rule = rules[record.code];
        if (!rule || codes.has(record.code) || !/^\d+$/.test(String(record.variantId)) || next.has(String(record.variantId)) || !/^gid:\/\/shopify\/Product\/\d+$/.test(record.productId || '') || !/^chic-[a-z0-9-]+$/.test(record.handle || '') || handles.has(record.handle) || !record.title || record.piece !== rule[0] || record.price !== rule[1] || record.capacity !== rule[2] || Boolean(record.fixedHeart) !== rule[3] || !['DRAFT', 'ACTIVE'].includes(record.status) || typeof record.previewOnly !== 'boolean' || record.status === 'DRAFT' && !record.previewOnly || !record.photo || !['oval-fine', 'oval-bold', 'oval-small', 'oval-dense', 'collar'].includes(record.linkStyle)) return;
        const copy = /^(pt|es)(-|$)/i.test(this.config.locale || '') ? this.config.baseCopy?.[record.code] || {} : {};
        const caption = /^(pt|es)(-|$)/i.test(this.config.locale || '') ? this.config.baseCaptions?.[record.caption] || record.caption : record.caption;
        next.set(String(record.variantId), { ...record, title: copy.title || record.title, caption, variantId: String(record.variantId) }); codes.add(record.code); handles.add(record.handle);
      }
      this.baseCatalog = next;
      for (const record of next.values()) if (this.pieces().includes(record.piece)) this.mergeProduct({ ...record, key: `variant_${record.variantId}`, kind: 'base', available: false, liveVerified: false, crop: record.crop || `0 0 ${record.imageWidth || 1024} ${record.imageHeight || 1024}`, imageWidth: record.imageWidth || 1024, imageHeight: record.imageHeight || 1024 });
    }
    baseRecord(base = this.base()) { return base && this.baseCatalog?.get(String(base.variantId)); }
    purchaseBaseReady(base = this.base()) {
      const record = this.baseRecord(base);
      return Boolean(record && record.status === 'ACTIVE' && record.previewOnly === false && this.config.previewOnly !== true && base.available === true && base.liveVerified === true && base.handle === record.handle && base.price === record.price);
    }
    async refreshActiveBases() {
      for (const product of this.products.filter(product => product.kind === 'base')) {
        const record = this.baseRecord(product);
        if (record?.status !== 'ACTIVE' || record.previewOnly || this.config.previewOnly === true) continue;
        const live = await this.getJSON(this.variantURL(record.handle, [], record.variantId));
        const valid = String(live?.variantId) === record.variantId && String(live.productId) === record.productId.split('/').pop() && live.currency === 'USD' && live.handle === record.handle && live.available === true && live.price === record.price;
        Object.assign(product, { available: valid, liveVerified: valid, inventoryLimited: live?.inventoryLimited === true, inventoryQuantity: live?.inventoryQuantity || 0 });
      }
    }
    disconnectedCallback() {
      this.gridObserver?.disconnect();
      document.removeEventListener('click', this.gridClick, true);
      document.removeEventListener('change', this.gridChange);
    }
    mergeProduct(source) {
      if (this.usesBaseCatalog() && source.kind === 'base' && (!this.baseCatalog?.has(String(source.variantId)) || this.baseCatalog.get(String(source.variantId)).handle !== source.handle || !this.pieces().includes(source.piece))) return null;
      if (!source?.variantId) return null;
      const existing = this.lookup.get(`variant_${source.variantId}`);
      if (existing?.kind === 'base' && source.kind !== 'base') return existing;
      const samePhoto = existing?.photo && source.photo && new URL(existing.photo, location.href).pathname === new URL(source.photo, location.href).pathname;
      const product = { ...existing, ...source, buildPrice: source.buildPrice ?? null, buildPriceCurrency: source.buildPriceCurrency ?? null, buildPriceSource: source.buildPriceSource ?? null, nativeBuild: source.nativeBuild ?? null, key: existing?.key || source.key || `variant_${source.variantId}`, productTitle: source.productTitle || existing?.productTitle || source.title, needsRefresh: Boolean(source.needsRefresh) };
      if (samePhoto && existing) Object.assign(product, { crop: existing.crop, previewWidth: existing.previewWidth });
      const prepared = preparedCharmPhotos[product.handle];
      const wholePhotoCrop = `0 0 ${product.imageWidth} ${product.imageHeight}`;
      if (product.kind === 'charm' && product.photo && prepared && product.crop === wholePhotoCrop && Number(product.imageWidth) === prepared[1] && Number(product.imageHeight) === prepared[2] && new URL(product.photo, location.href).pathname.endsWith('/' + prepared[0])) {
        product.crop = prepared[3];
        product.previewWidth = prepared[4];
      }
      if (existing) Object.assign(existing, product); else this.products.push(product);
      const record = existing || product;
      this.lookup.set(record.key, record);
      this.lookup.set(`variant_${record.variantId}`, record);
      if (record.deferred && record.optionGroups?.length) this.deferredGroups.set(record.handle, record.optionGroups);
      return record;
    }
    groups(kind = 'charm') {
      const groups = new Map();
      for (const product of this.products.filter(product => product.kind === kind && (kind !== 'charm' || !this.catalogFetched || this.catalogHandles.has(product.handle)))) {
        if (!groups.has(product.handle)) groups.set(product.handle, { handle: product.handle, title: product.productTitle || product.title, variants: [] });
        groups.get(product.handle).variants.push(product);
      }
      return [...groups.values()];
    }
    choice(handle) {
      const variants = this.products.filter(product => product.handle === handle);
      return this.lookup.get(this.variantChoices.get(handle)) || variants.find(product => product.available) || variants[0];
    }
    optionMarkup(handle, variants, grid = false) {
      const current = this.choice(handle), state = this.variantStates.get(handle) || {};
      const options = this.deferredGroups.get(handle);
      if (options) return options.map(option => `<label class="variant-label">${this.safe(option.name)}<select data-option-handle="${this.safe(handle)}" data-option-position="${option.position}"${state.loading ? ' disabled' : ''}>${option.values.map(value => `<option value="${this.safe(value.id)}"${value.selected ? ' selected' : ''}${value.available === false ? ' disabled' : ''}>${this.safe(value.name)}${value.available === false ? ' · ' + this.safe(this.t('sold_out')) : ''}</option>`).join('')}</select></label>`).join('');
      if (variants.length < 2) return '';
      return `<label class="variant-label">${this.safe(this.t('variant_label'))}<select ${grid ? 'data-atelier-grid-variant' : 'data-variant-handle'}="${this.safe(handle)}"${this.busy ? ' disabled' : ''}>${variants.map(product => `<option value="${this.safe(product.key)}"${product.key === current?.key ? ' selected' : ''}${!product.available ? ' disabled' : ''}>${this.safe(product.variantTitle || product.title)}${!product.available ? ' · ' + this.safe(this.t('sold_out')) : ''}</option>`).join('')}</select></label>`;
    }
    captureFocus(container) {
      const active = document.activeElement;
      if (!container.contains(active)) return null;
      const card = active.closest('[data-charm-handle], [data-atelier-grid-control]');
      if (!card) return null;
      const handle = card.dataset.charmHandle || card.dataset.atelierGridControl;
      if (active === card && container.atelierFocus?.handle === handle) return container.atelierFocus;
      const attributes = ['data-product', 'data-variant-handle', 'data-option-handle', 'data-option-position', 'data-atelier-grid-variant', 'data-atelier-grid-add', 'data-variant-retry'].filter(name => active.hasAttribute(name)).map(name => [name, active.getAttribute(name)]);
      return container.atelierFocus = { handle, tag: active.tagName.toLowerCase(), attributes };
    }
    restoreFocus(container, focus) {
      if (!focus) return;
      const card = container.matches('[data-atelier-grid-control]') ? container : container.querySelector(`[data-charm-handle="${CSS.escape(focus.handle)}"]`);
      if (!card) return;
      container.atelierFocus = focus;
      const selector = focus.tag + focus.attributes.map(([name, value]) => `[${name}="${CSS.escape(value)}"]`).join('');
      const control = focus.attributes.length ? card.querySelector(selector) : null;
      if (control && !control.disabled) control.focus({ preventScroll: true });
      else { card.tabIndex = -1; card.focus({ preventScroll: true }); }
    }
    renderCatalog() {
      const catalog = this.$('catalog');
      if (!catalog) return;
      const scroll = catalog.scrollTop;
      const focus = this.captureFocus(catalog);
      const groups = this.groups().filter(group => `${group.title} ${group.variants.map(product => product.variantTitle || '').join(' ')}`.toLocaleLowerCase().includes(this.searchTerm));
      catalog.innerHTML = groups.length ? groups.map(group => {
        const product = this.choice(group.handle), state = this.variantStates.get(group.handle) || {};
        const count = group.variants.reduce((total, variant) => total + this.count(variant.key), 0);
        const selection = this.charmSelection(product);
        const disabled = state.loading || state.error || selection.reason || selection.action === 'unchanged';
        return `<article class="charm-product${!product?.available ? ' is-unavailable' : ''}" data-charm-handle="${this.safe(group.handle)}">${this.art(product, 'product-art')}<span class="product-name">${this.safe(group.title)}</span>${this.optionMarkup(group.handle, group.variants)}${state.loading || state.error ? `<span class="variant-status" role="status">${this.safe(state.loading ? this.t('variant_loading') : state.error)}</span>${state.error ? `<button type="button" data-variant-retry="${this.safe(group.handle)}">${this.safe(this.t('catalog_retry'))}</button>` : ''}` : ''}${this.priceMarkup(product)}<button type="button" class="add-charm-button" data-product="${this.safe(product?.key || '')}" aria-label="${this.safe(this.charmSelectionAria(product?.title || group.title, selection))}"${disabled ? ' disabled' : ''}>${this.safe(this.charmSelectionLabel(product, selection))}</button>${count ? `<span class="product-count">${count}</span>` : ''}</article>`;
      }).join('') : `<p class="empty-catalog">${this.safe(this.t(this.searchTerm ? 'catalog_no_results' : 'no_charms'))}</p>`;
      catalog.scrollTop = scroll;
      this.restoreFocus(catalog, focus);
      if (this.$('catalog-count')) this.$('catalog-count').textContent = this.t('catalog_results', { count: groups.length });
      if (this.$('catalog-status')) this.$('catalog-status').textContent = this.catalogLoading ? this.t('catalog_loading') : this.catalogError ? this.t('catalog_load_error') : '';
      if (this.$('catalog-more')) {
        this.$('catalog-more').hidden = !this.catalogNext && !this.catalogError;
        this.$('catalog-more').disabled = this.catalogLoading;
        this.$('catalog-more').textContent = this.t(this.catalogError ? 'catalog_retry' : 'catalog_load_more');
      }
      this.enhanceGrid();
    }
    variantURL(handle, optionIds, variantId) {
      const root = this.config.routesRoot.replace(/\/?$/, '/');
      const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('view', 'atelier-variant');
      if (optionIds?.length) url.searchParams.set('option_values', optionIds.join(','));
      else if (variantId) url.searchParams.set('variant', variantId);
      return url;
    }
    async getJSON(url) {
      const target = new URL(url, location.origin);
      if (target.origin !== location.origin) throw new Error(this.t('catalog_load_error'));
      const response = await fetch(target.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(this.t('catalog_load_error'));
      return response.json();
    }
    async loadCatalog(all = false) {
      if (this.catalogLoading || !this.catalogNext) return;
      this.catalogLoading = true;
      this.catalogError = false;
      this.renderCatalog();
      const seen = new Set();
      try {
        do {
          const url = this.catalogNext;
          if (seen.has(url)) throw new Error(this.t('catalog_load_error'));
          seen.add(url);
          const page = await this.getJSON(url);
          if (!Array.isArray(page.products)) throw new Error(this.t('catalog_load_error'));
          for (const product of page.products) if (!this.baseHandles.has(product.handle)) { this.catalogHandles.add(product.handle); this.mergeProduct(product); }
          this.catalogFetched = true;
          this.catalogNext = page.nextPage || null;
          this.renderCatalog();
          const missingSaved = this.rawSaved && this.pieces().some(piece => this.rawSaved[piece]?.slots?.some(key => key && (!this.lookup.has(key) || this.lookup.get(key)?.needsRefresh)));
          if (missingSaved && this.catalogNext) all = true;
        } while ((all || this.searchTerm) && this.catalogNext);
        if (!this.catalogNext) for (const product of this.products) if (product.kind === 'charm' && !this.catalogHandles.has(product.handle)) product.available = false;
        if (this.rawSaved && !this.designTouched) {
          for (const record of this.rawSaved.products || []) {
            if (record.deferred && record.resolvedOptionIds?.length) {
              try {
                const refreshed = await this.getJSON(this.variantURL(record.handle, record.resolvedOptionIds, record.variantId));
                if (String(refreshed.variantId) === String(record.variantId)) {
                  const hydrated = this.mergeProduct({ ...refreshed, resolvedOptionIds: record.resolvedOptionIds, kind: record.kind, piece: record.piece, linkStyle: record.linkStyle, caption: record.caption });
                  if (hydrated) this.variantChoices.set(hydrated.handle, hydrated.key);
                }
              } catch (_) {}
            }
          }
          for (const piece of this.pieces()) this.saved[piece] = this.normalize(this.rawSaved[piece], piece);
          if (this.saved[this.state.piece]) Object.assign(this.state, this.saved[this.state.piece]);
          this.rawSaved = null;
        }
      } catch (_) { this.catalogError = true; }
      finally { this.catalogLoading = false; this.render(); }
    }
    async onVariantChange(event) {
      const select = event.target;
      const handle = select.dataset.variantHandle || select.dataset.atelierGridVariant || select.dataset.optionHandle;
      if (!handle || this.busy) return;
      event.stopPropagation();
      if (!select.dataset.optionHandle) {
        this.variantChoices.set(handle, select.value);
        this.renderCatalog();
        return;
      }
      const groups = this.deferredGroups.get(handle);
      for (const group of groups || []) if (String(group.position) === select.dataset.optionPosition) for (const value of group.values) value.selected = String(value.id) === select.value;
      const optionIds = (groups || []).map(group => group.values.find(value => value.selected)?.id).filter(Boolean);
      this.variantStates.set(handle, { loading: true });
      this.renderCatalog();
      try {
        const product = await this.getJSON(this.variantURL(handle, optionIds));
        if (product.optionGroups?.length) this.deferredGroups.set(handle, product.optionGroups);
        const existing = this.products.find(value => value.handle === handle);
        const resolved = this.mergeProduct({ ...product, kind: existing?.kind || 'charm', piece: existing?.piece || 'charm', linkStyle: existing?.linkStyle, caption: existing?.caption, resolvedOptionIds: optionIds });
        if (resolved) this.variantChoices.set(handle, resolved.key);
        if (!resolved || !resolved.available) throw new Error(this.t('variant_unavailable'));
        if (existing?.kind === 'base') { this.state.base = resolved.key; this.designTouched = true; this.persist(); }
        this.variantStates.set(handle, {});
      } catch (error) { this.variantStates.set(handle, { error: error.message === this.t('variant_unavailable') ? error.message : this.t('variant_error') }); }
      this.render();
    }
    enhanceGrid() {
      if (!this.isConnected || !this.products.length) return;
      const groups = new Map(this.groups().map(group => [group.handle, group]));
      for (const card of document.querySelectorAll('.main-featured-product-grid_wrapper .product-item')) {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) continue;
        const handle = new URL(link.href, location.href).pathname.split('/products/')[1]?.split('/')[0];
        const group = groups.get(handle);
        if (!group) continue;
        let control = card.querySelector('[data-atelier-grid-control]');
        if (control?.dataset.atelierGridOwner && control.dataset.atelierGridOwner !== this.config.sectionId) continue;
        card.classList.add('atelier-linked');
        if (!control) { control = document.createElement('div'); control.className = 'atelier-grid-control'; control.dataset.atelierGridControl = handle; (card.querySelector('.product-info') || card).append(control); }
        control.dataset.atelierGridOwner = this.config.sectionId;
        const product = this.choice(handle), state = this.variantStates.get(handle) || {};
        const selection = this.charmSelection(product);
        const count = group.variants.reduce((total, variant) => total + this.count(variant.key), 0);
        const markup = `${this.optionMarkup(handle, group.variants, true)}${state.loading || state.error ? `<span class="variant-status" role="status">${this.safe(state.loading ? this.t('variant_loading') : state.error)}</span>` : ''}${state.error ? `<button type="button" data-variant-retry="${this.safe(handle)}">${this.safe(this.t('catalog_retry'))}</button>` : ''}<button type="button" data-atelier-grid-add="${this.safe(handle)}" aria-label="${this.safe(this.charmSelectionAria(product?.title || group.title, selection))}"${state.loading || state.error || selection.reason || selection.action === 'unchanged' ? ' disabled' : ''}>${this.safe(this.charmSelectionLabel(product, selection))}</button><span class="atelier-grid-count">${count ? this.safe(this.t('design_count', { count })) : ''}</span>`;
        if (control.chicAtelierMarkup !== markup || control.chicAtelierRenderedMarkup !== control.innerHTML) {
          const focus = this.captureFocus(control);
          control.innerHTML = markup;
          control.chicAtelierMarkup = markup;
          control.chicAtelierRenderedMarkup = control.innerHTML;
          this.restoreFocus(control, focus);
        }
      }
      this.gridObserver?.takeRecords();
    }
    charmSelection(product) {
      const unavailable = reason => ({ index: -1, action: 'add', reason });
      if (this.busy) return unavailable('adding');
      const base = this.base();
      if (!base || base.kind !== 'base' || base.piece !== this.state.piece || this.usesBaseCatalog() && (!this.baseRecord(base) || this.state.slots.length !== this.capacity())) return unavailable('choose_base_for_set');
      if (product?.kind !== 'charm' || !product.available) return unavailable('stock_limit');
      if (!this.designCharmReady(product)) return unavailable('design_pricing_unavailable');
      const centerpiece = this.usesBaseCatalog() && this.state.piece === 'collar' && this.capacity() === 1;
      const index = centerpiece ? 0 : this.state.slots[this.state.selected] === null ? this.state.selected : this.state.slots.indexOf(null);
      if (index < 0 || index >= this.capacity()) return unavailable('design_full');
      const previous = this.state.slots[index];
      if (centerpiece && previous === product.key) return { index, action: 'unchanged', reason: null };
      if (this.count(product.key) - (previous === product.key ? 1 : 0) >= this.remaining(product)) return unavailable('stock_limit');
      return { index, action: centerpiece && previous ? 'replace' : 'add', reason: null };
    }
    charmSelectionLabel(product, selection = this.charmSelection(product)) {
      if (!product?.available) return this.t('sold_out');
      const labels = { choose_base_for_set: 'choose_base_button', design_full: 'design_full_button', design_pricing_unavailable: 'design_price_unavailable', stock_limit: 'stock_limit_button', adding: 'adding' };
      if (selection.reason) return this.t(labels[selection.reason] || 'add_to_design');
      if (this.usesBaseCatalog() && this.state.piece === 'collar') return this.t({ add: 'select_centerpiece', replace: 'replace_centerpiece', unchanged: 'selected_centerpiece' }[selection.action]);
      return this.t('add_to_design');
    }
    charmSelectionAria(title, selection) {
      const key = this.usesBaseCatalog() && this.state.piece === 'collar' ? { add: 'select_product_centerpiece', replace: 'replace_product_centerpiece', unchanged: 'selected_product_centerpiece' }[selection.action] : 'add_product_to_set';
      return this.t(key, { title });
    }
    addCharm(key) {
      const product = this.lookup.get(key);
      const selection = this.charmSelection(product);
      if (selection.reason) return this.notify(this.t(selection.reason), selection.reason === 'design_pricing_unavailable');
      if (selection.action === 'unchanged') return this.notify(this.t('selected_product_centerpiece', { title: product.title }));
      const index = selection.index;
      this.state.slots[index] = product.key;
      this.state.selected = index;
      this.designTouched = true;
      this.notify(this.t(selection.action === 'replace' ? 'replaced_centerpiece' : 'added_position', { title: product.title, position: index + 1 }));
      this.persist();
      this.render();
    }
    t(key, values = {}) {
      if (this.state?.piece === 'collar') key = ({ base_plus_charms_note: 'base_plus_pendant_note', base_plus_charms_breakdown: 'base_plus_pendant_breakdown', choose_base_placeholder: 'choose_collar_placeholder', charm_count: 'pendant_count', empty_space: 'pendant_empty_space', add_hint: 'pendant_add_hint', positions_note: 'pendant_position_note', preview_label: 'pendant_preview_label' })[key] || key;
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, String(value)), this.config.strings[key] || key);
    }
    safe(value) { return String(value).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]); }
    money(amount) { return new Intl.NumberFormat(this.config.locale || 'en-US', { style: 'currency', currency: this.config.currency || 'USD' }).format(amount / 100); }
    designPricingActive() { return this.config.designPricing?.enabled === true && this.config.currency === 'USD' && this.config.designPricing.currency === 'USD' && this.config.designPricing.offer === 'atelier-starter-usd-v4' && Number(this.config.designPricing.lowerCents) === 2000 && Number(this.config.designPricing.cents) === 2500 && Number(this.config.designPricing.thresholdCents) === 2500; }
    validBuildPrice(product) {
      const native = product?.nativeBuild;
      return Number.isSafeInteger(product?.price) && product.price >= 0 && Number.isSafeInteger(product.buildPrice) && product.buildPrice === (product.price <= 2500 ? 2000 : 2500) && product.buildPriceCurrency === 'USD' && ['variant', 'product'].includes(product.buildPriceSource) && native?.variantCount === 1 && /^\d+$/.test(String(native.variantId)) && String(native.variantId) !== String(product.variantId) && String(native.sourceVariantId) === String(product.variantId) && native.currency === 'USD' && native.available === true && Number.isSafeInteger(native.price) && native.price === Math.min(product.price, product.buildPrice);
    }
    configureStarterBundles() {
      const source = this.config.starterBundles;
      if (source?.version !== 1 || source.currency !== 'USD' || source.handle !== 'chic-atelier-starter-bundle' || !Array.isArray(source.bases) || !Array.isArray(source.bundles) || !source.bundles.length) return;
      const bases = new Map(), variantIds = new Set(), next = new Map();
      for (const base of source.bases) {
        const expected = base.piece === 'bracelet' ? [4000, 6000] : base.piece === 'necklace' ? [8000, 10000] : [];
        if (!/^\d+$/.test(String(base.variantId)) || bases.has(String(base.variantId)) || !expected.includes(base.price) || base.total !== base.price + 2000 || !base.handle || !base.title) return;
        bases.set(String(base.variantId), base);
      }
      for (const entry of source.bundles) {
        const base = bases.get(String(entry.baseVariantId));
        const key = `${entry.baseVariantId}:${entry.charmVariantId}`;
        if (!base || !/^\d+$/.test(String(entry.variantId)) || !/^\d+$/.test(String(entry.charmVariantId)) || variantIds.has(String(entry.variantId)) || next.has(key) || entry.baseHandle !== base.handle || !entry.charmHandle || entry.price !== base.total || String(entry.variantId) === String(entry.baseVariantId) || String(entry.variantId) === String(entry.charmVariantId)) return;
        next.set(key, { ...entry, base });
        variantIds.add(String(entry.variantId));
      }
      this.starterMap = next;
    }
    starterRecord(base = this.base(), charm = this.lookup.get(this.state.slots[this.includedCharmIndex()])) {
      if (!base || !charm) return null;
      const record = this.starterMap.get(`${base.variantId}:${charm.variantId}`);
      return record && record.baseHandle === base.handle && record.charmHandle === charm.handle && record.base.piece === base.piece && record.base.price === base.price && record.price === base.price + 2000 ? record : null;
    }
    starterStateReady(record) {
      if (!record) return false;
      const known = this.starterMap.get(`${record.baseVariantId}:${record.charmVariantId}`);
      const state = known && this.starterStates.get(String(known.variantId));
      return Boolean(known && String(record.variantId) === String(known.variantId) && record.baseHandle === known.baseHandle && record.charmHandle === known.charmHandle && record.price === known.price && String(record.base?.variantId) === String(known.baseVariantId) && record.base?.price === known.base.price && known.price === known.base.total && known.base.total === known.base.price + 2000 && state && String(state.variantId) === String(known.variantId) && state.available === true && Number.isSafeInteger(state.price) && state.price === known.price && typeof state.option1 === 'string' && state.option1.trim() !== '' && typeof state.option2 === 'string' && state.option2.trim() !== '' && (state.inventoryLimited !== true || Number.isInteger(state.inventoryQuantity) && state.inventoryQuantity > 0));
    }
    async refreshStarterBundles() {
      if (!this.starterMap.size) throw new Error(this.t('design_pricing_unavailable'));
      const root = this.config.routesRoot.replace(/\/?$/, '/');
      const url = new URL(`${root}products/${encodeURIComponent(this.config.starterBundles.handle)}`, location.origin);
      url.searchParams.set('view', 'atelier-starter');
      const source = await this.getJSON(url);
      if (source?.handle !== this.config.starterBundles.handle || source.currency !== 'USD' || source.variantCount !== this.starterMap.size || !Array.isArray(source.variants) || source.variants.length !== this.starterMap.size) throw new Error(this.t('design_pricing_unavailable'));
      const records = new Map();
      for (const variant of source.variants) {
        if (!/^\d+$/.test(String(variant.variantId)) || records.has(String(variant.variantId)) || !Number.isSafeInteger(variant.price) || typeof variant.available !== 'boolean') throw new Error(this.t('design_pricing_unavailable'));
        records.set(String(variant.variantId), variant);
      }
      if ([...this.starterMap.values()].some(record => !records.has(String(record.variantId)))) throw new Error(this.t('design_pricing_unavailable'));
      this.starterStates = records;
      return records;
    }
    firstCharmIndex() { return this.state.slots.findIndex(Boolean); }
    compareIncludedCharms(left, right) {
      const priceDifference = right.product.nativeBuild.price - left.product.nativeBuild.price;
      if (priceDifference) return priceDifference;
      const leftId = String(left.product.variantId).replace(/^0+(?=\d)/, ''), rightId = String(right.product.variantId).replace(/^0+(?=\d)/, '');
      if (leftId.length !== rightId.length) return leftId.length - rightId.length;
      if (leftId !== rightId) return leftId < rightId ? -1 : 1;
      const leftHandle = String(left.product.handle), rightHandle = String(right.product.handle);
      if (leftHandle !== rightHandle) return leftHandle < rightHandle ? -1 : 1;
      return left.index - right.index;
    }
    includedCharmIndex(slots = this.state.slots) {
      if (this.usesBaseCatalog()) return -1;
      const base = this.base();
      if (!this.designPricingActive() || !base?.available) return -1;
      const eligible = slots.map((key, index) => ({ product: this.lookup.get(key), index })).filter(({ product }) => {
        if (!product?.available || !this.validBuildPrice(product)) return false;
        const record = this.starterRecord(base, product);
        return Boolean(record && (!this.starterStates.has(String(record.variantId)) || this.starterStateReady(record)));
      });
      eligible.sort((left, right) => this.compareIncludedCharms(left, right));
      return eligible[0]?.index ?? -1;
    }
    slotPrice(index) {
      const product = this.lookup.get(this.state.slots[index]);
      return product && index === this.includedCharmIndex() ? 2000 : this.designPrice(product);
    }
    nextCharmPrice(product) {
      return this.projectedCharmIncrement(product) ?? this.designPrice(product);
    }
    designCharmReady(product) {
      if (this.usesBaseCatalog()) return Boolean(product?.kind === 'charm' && this.designPricingActive() && this.validBuildPrice(product));
      if (product?.kind !== 'charm' || !this.designPricingActive()) return true;
      if (!this.validBuildPrice(product) || !this.starterMap.size) return false;
      const base = this.base();
      const record = base ? this.starterRecord(base, product) : [...this.starterMap.values()].find(value => String(value.charmVariantId) === String(product.variantId) && value.charmHandle === product.handle);
      return Boolean(record && (!this.starterStates.has(String(record.variantId)) || this.starterStateReady(record)));
    }
    designPrice(product) { return product?.kind === 'charm' && this.designPricingActive() && this.validBuildPrice(product) ? Math.min(product.price, product.buildPrice) : product?.price || 0; }
    starterQuote(base = this.base()) {
      if (this.usesBaseCatalog()) return null;
      if (!this.designPricingActive() || !base?.available) return null;
      const record = [...this.starterMap.values()].find(entry => String(entry.baseVariantId) === String(base.variantId) && entry.baseHandle === base.handle && entry.base.piece === base.piece && entry.base.price === base.price && entry.price === entry.base.total && (!this.starterStates.has(String(entry.variantId)) || this.starterStateReady(entry)));
      return record ? record.price : null;
    }
    baseOptionText(product) {
      if (this.usesBaseCatalog()) return `${product.title} · ${this.money(product.price)}`;
      const price = this.starterQuote(product);
      return this.t(price === null ? 'set_option' : 'set_option_price', { title: product.title, price: price === null ? '' : this.money(price) });
    }
    projectedCharmIncrement(product) {
      if (!product) return null;
      const slots = [...this.state.slots];
      const selection = this.charmSelection(product);
      if (selection.reason) return null;
      if (selection.action === 'unchanged') return 0;
      const index = selection.index;
      slots[index] = product.key;
      const included = this.includedCharmIndex(slots);
      const charms = slots.reduce((total, key, position) => {
        const charm = this.lookup.get(key);
        return total + (charm && position === included ? 2000 : this.designPrice(charm));
      }, 0);
      return charms - this.amounts().charms;
    }
    setPresentation() {
      if (this.usesBaseCatalog()) {
        const base = this.base(), count = this.state.slots.filter(Boolean).length;
        const ready = this.state.slots.every(key => !key || this.designCharmReady(this.lookup.get(key)));
        return { starterLabel: this.t('base_only_label'), starterAmount: base?.price ?? null, includes: base?.fixedHeart ? this.t('attached_heart_included') : this.t('base_plus_charms_note'), totalLabel: this.t('design_total'), totalAmount: base && ready ? this.amounts().total : null, breakdown: !base ? this.t('choose_base_for_set') : count ? this.t('base_plus_charms_breakdown', { base: this.money(base.price), charms: this.money(this.amounts().charms) }) : this.t('base_plus_charms_note'), charmHeading: this.t(this.state.piece === 'collar' ? 'choose_pendant' : 'choose_charms'), included: false };
      }
      const base = this.base(), firstIndex = this.firstCharmIndex(), includedIndex = this.includedCharmIndex();
      const first = this.lookup.get(this.state.slots[firstIndex]);
      const count = this.state.slots.filter(Boolean).length;
      const active = this.designPricingActive(), quote = this.starterQuote(base);
      const included = Boolean(active && quote !== null && includedIndex >= 0 && this.state.slots.every(key => !key || this.lookup.get(key)?.available && this.designCharmReady(this.lookup.get(key))));
      const usable = !active || included;
      const starter = base && first ? usable ? base.price + this.slotPrice(active ? includedIndex : firstIndex) : null : quote;
      const total = base ? first ? usable ? this.amounts().total : null : quote : null;
      const prompt = !base ? this.t('choose_base_for_set') : active && quote === null ? this.t('design_price_unavailable') : this.t('starter_set_price_pending');
      return {
        starterLabel: this.t('starter_set_label', { piece: this.t(this.state.piece) }),
        starterAmount: base ? starter : null,
        includes: !base ? prompt : first ? included ? this.t('starter_set_includes') : active ? this.t('design_price_unavailable') : this.t('starter_set_priced_charm') : quote === null ? prompt : this.t('starter_set_choose_charm'),
        totalLabel: this.t(first && base ? 'set_total_label' : 'starter_total_label'),
        totalAmount: total,
        breakdown: !base || !first ? first || quote === null ? prompt : this.t('starter_set_choose_charm') : included ? count === 1 ? this.t('set_one_charm_breakdown') : this.t('set_breakdown', { starter: this.money(starter), additional: this.money(total - starter) }) : active ? this.t('design_price_unavailable') : this.t(count === 1 ? 'set_one_charm_breakdown' : 'set_standard_breakdown', { count }),
        charmHeading: this.t(first ? 'additional_charm_heading' : quote === null ? 'choose_charms' : 'first_charm_heading'),
        included
      };
    }
    priceMarkup(product) {
      if (this.usesBaseCatalog()) return `<span class="product-price">${this.safe(this.designCharmReady(product) ? this.t('additional_charm_increment', { price: this.money(this.designPrice(product)) }) : this.t('design_price_unavailable'))}</span>`;
      const active = product?.kind === 'charm' && this.designPricingActive();
      const ready = this.designCharmReady(product);
      const base = this.base(), first = this.firstCharmIndex();
      let label;
      if (!base) label = this.t('choose_base_for_set');
      else if (active && (!ready || this.starterQuote(base) === null)) label = this.t('design_price_unavailable');
      else if (first < 0) label = active && this.starterRecord(base, product) ? this.t('included_in_starter_set') : this.t('set_with_charm', { price: this.money(base.price + this.designPrice(product)) });
      else {
        const increment = this.projectedCharmIncrement(product);
        label = increment === null ? this.t('design_full') : this.t('additional_charm_increment', { price: this.money(increment) });
      }
      return `<span class="product-price">${this.safe(label)}</span>`;
    }
    capacity(piece = this.state.piece, base = this.base()) {
      if (this.usesBaseCatalog()) return base?.piece === piece && this.baseRecord(base) ? this.baseRecord(base).capacity : ({ necklace: 9, bracelet: 7, collar: 1 }[piece] || 1);
      return Number(this.config.capacities[piece]);
    }
    base() { return this.lookup.get(this.state?.base); }
    normalize(value, piece) {
      if (!value || !Array.isArray(value.slots)) return null;
      const validBase = this.lookup.get(value.base);
      if (this.usesBaseCatalog() && value.slots.slice(this.capacity(piece, validBase)).some(Boolean)) return null;
      const slots = Array(this.capacity(piece, validBase)).fill(null).map((_, index) => {
        const product = this.lookup.get(value.slots[index]);
        return product && product.kind === 'charm' ? product.key : null;
      });
      return { piece, base: validBase && validBase.kind === 'base' && validBase.piece === piece ? validBase.key : '', slots, selected: Math.max(0, Math.min(slots.length - 1, Number(value.selected) || 0)) };
    }
    persist() {
      this.saved[this.state.piece] = { ...this.state, slots: [...this.state.slots] };
      const serialized = {};
      const records = new Map();
      for (const piece of this.pieces()) {
        const value = this.saved[piece];
        if (!value) { serialized[piece] = null; continue; }
        const variantKey = key => { const product = this.lookup.get(key); if (!product) return null; records.set(String(product.variantId), product); return `variant_${product.variantId}`; };
        serialized[piece] = { ...value, base: variantKey(value.base) || '', slots: value.slots.map(variantKey) };
      }
      try { localStorage.setItem(this.storageKey, JSON.stringify({ version: 2, ...serialized, products: [...records.values()] })); } catch (_) {}
    }
    storedPending() {
      try {
        const value = JSON.parse(localStorage.getItem(this.pendingKey));
        if (value && typeof value.buildId === 'string' && Array.isArray(value.items)) return value;
      } catch (_) {}
      return null;
    }
    rememberPending(buildId, items) {
      this.pendingBuild = buildId;
      try { localStorage.setItem(this.pendingKey, JSON.stringify({ buildId, items })); } catch (_) {}
    }
    forgetPending(buildId) {
      try { if (this.storedPending()?.buildId === buildId) localStorage.removeItem(this.pendingKey); } catch (_) {}
    }
    async recoverPending(pending) {
      this.busy = true;
      this.pendingBuild = pending.buildId;
      this.render();
      try {
        const cart = await this.readCart();
        if (await this.verifiedCheckout(cart, pending.items, pending.buildId)) {
          this.forgetPending(pending.buildId);
          this.notify(this.t('added_cart'));
          this.$('cart-link').classList.remove('is-hidden');
          location.assign(this.config.cartUrl);
          return;
        }
        const pricingUnavailable = this.matchesBuild(cart, pending.items, pending.buildId) && !this.pricingVerified(cart, pending.items, pending.buildId);
        const recovered = await this.rollbackBuild(cart, pending.buildId);
        this.updateCartQuantities(recovered);
        this.forgetPending(pending.buildId);
        this.pendingBuild = null;
        this.notify(this.t(pricingUnavailable ? 'design_pricing_unavailable' : 'recovery_cleared'), pricingUnavailable);
      } catch (_) {
        this.review();
        this.notify(this.t('cart_uncertain'), true);
        this.$('cart-link').classList.remove('is-hidden');
        if (!this.$('review-dialog').open) this.$('review-dialog').showModal();
      } finally {
        this.busy = false;
        this.render();
      }
    }
    amounts() {
      const charms = this.state.slots.reduce((total, key, index) => total + this.slotPrice(index), 0);
      return { charms, base: this.base()?.price || 0, total: charms + (this.base()?.price || 0) };
    }
    count(key) { return this.state.slots.filter(value => value === key).length; }
    remaining(product) {
      if (!product.available) return 0;
      let stock = product.inventoryLimited ? Number(product.inventoryQuantity) : Infinity;
      if (product.kind === 'charm' && this.designPricingActive()) {
        if (!this.validBuildPrice(product)) return 0;
        if (product.nativeBuild.inventoryLimited) stock = Math.min(stock, Number(product.nativeBuild.inventoryQuantity));
      }
      return Math.max(0, stock - (this.cartQuantities.get(String(product.variantId)) || 0));
    }
    notify(message, error = false) {
      this.$('status').textContent = message;
      if (error) this.$('cart-error').textContent = message;
    }
    art(product, className = '') {
      if (!product?.photo) return '<span aria-hidden="true">◇</span>';
      return `<svg class="${className}" viewBox="${product.crop}" aria-hidden="true"><image href="${this.safe(product.photo)}" width="${product.imageWidth}" height="${product.imageHeight}" /></svg>`;
    }
    render() {
      const currentBase = this.base();
      const presentation = this.setPresentation();
      const selected = this.lookup.get(this.state.slots[this.state.selected]);
      const selectedCount = this.state.slots.filter(Boolean).length;
      this.querySelectorAll('[data-piece]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.piece === this.state.piece));
        button.disabled = this.busy;
      });
      this.$('base').innerHTML = `<option value="">${this.safe(this.t('choose_base_placeholder'))}</option>` + this.products.filter(product => product.kind === 'base' && product.piece === this.state.piece).map(product => `<option value="${this.safe(product.key)}"${product.key === this.state.base ? ' selected' : ''}${!this.usesBaseCatalog() && (!product.available || this.remaining(product) < 1) ? ' disabled' : ''}>${this.safe(this.baseOptionText(product))}${!this.usesBaseCatalog() && !product.available ? ' · ' + this.safe(this.t('sold_out')) : ''}</option>`).join('');
      this.$('base').disabled = this.busy;
      if (this.$('base-options')) this.$('base-options').innerHTML = currentBase?.deferred ? this.optionMarkup(currentBase.handle, this.products.filter(product => product.handle === currentBase.handle)) : '';
      if (this.$('base-photo')) this.$('base-photo').innerHTML = currentBase ? this.art(currentBase, 'base-preview-photo') : '';
      if (this.$('base-hardware')) {
        this.$('base-hardware').innerHTML = currentBase?.hardwarePhoto && currentBase.hardwareCrop ? this.art({ photo: currentBase.hardwarePhoto, crop: currentBase.hardwareCrop, imageWidth: currentBase.hardwareImageWidth, imageHeight: currentBase.hardwareImageHeight }, 'base-hardware-photo') : '';
        const details = this.$('base-hardware').closest?.('details');
        if (details) details.hidden = !currentBase?.hardwarePhoto;
      }
      this.$('base-details').textContent = currentBase?.caption || this.t('choose_base_hint');
      this.$('base-price').textContent = presentation.starterAmount === null ? '' : this.money(presentation.starterAmount);
      if (this.$('starter-label')) this.$('starter-label').textContent = presentation.starterLabel;
      if (this.$('starter-includes')) this.$('starter-includes').textContent = presentation.includes;
      if (this.$('charm-heading')) this.$('charm-heading').textContent = presentation.charmHeading;
      if (this.$('positions-note')) this.$('positions-note').textContent = this.t('positions_note');
      this.$('base-caption').textContent = currentBase?.title || this.t('choose_base_hint');
      this.$('count').textContent = this.t('charm_count', { count: selectedCount + (currentBase?.fixedHeart ? 1 : 0) });
      this.$('capacity').textContent = this.t('capacity_count', { count: selectedCount + (currentBase?.fixedHeart ? 1 : 0), capacity: this.state.slots.length + (currentBase?.fixedHeart ? 1 : 0) });
      this.$('selected-name').textContent = selected?.title || this.t('empty_space');
      this.$('add-hint').textContent = this.t('add_hint', { piece: this.t(this.state.piece) });
      this.$('total').textContent = presentation.totalAmount === null ? '' : this.money(presentation.totalAmount);
      if (this.$('total-label')) this.$('total-label').textContent = presentation.totalLabel;
      this.$('breakdown').textContent = presentation.breakdown;
      const bestValueAvailable = this.designPricingActive() && this.starterQuote(currentBase) !== null;
      if (this.$('best-value-heading')) {
        this.$('best-value-heading').textContent = bestValueAvailable ? this.t('best_set_price_label') : '';
        this.$('best-value-heading').hidden = !bestValueAvailable;
      }
      if (this.$('pricing-note')) this.$('pricing-note').textContent = bestValueAvailable ? this.t('best_set_price_note') : this.designPricingActive() ? this.t('design_pricing_note', { lower: this.money(2000), upper: this.money(2500), threshold: this.money(2500) }) : this.t('pricing_note');
      if (this.usesBaseCatalog() && this.$('pricing-note')) this.$('pricing-note').textContent = this.t(this.purchaseBaseReady() ? 'base_plus_charms_note' : 'draft_checkout_disabled');
      this.$('slots').style.setProperty('--chic-slots', this.state.slots.length);
      const includedIndex = presentation.included ? this.includedCharmIndex() : -1;
      this.$('slots').innerHTML = this.state.slots.map((key, index) => `<button class="slot-button" type="button" data-slot="${index}" aria-pressed="${index === this.state.selected}" aria-label="${this.safe(this.t('position_label', { position: index + 1, title: this.lookup.get(key)?.title || this.t('empty') }) + (index === includedIndex ? ' · ' + this.t('included_in_starter_set') : ''))}"${this.busy ? ' disabled' : ''}>${key ? this.art(this.lookup.get(key)) : '<div class="empty-slot" aria-hidden="true">+</div>'}<span>${index + 1}</span>${index === includedIndex ? `<span class="slot-included-label" title="${this.safe(this.t('included_in_starter_set'))}">${this.safe(this.t('review_included'))}</span>` : ''}</button>`).join('');
      this.renderCatalog();
      this.$('remove').disabled = this.busy || !selected;
      this.querySelector('[data-move="-1"]').disabled = this.busy || !selected || this.state.selected === 0;
      this.querySelector('[data-move="1"]').disabled = this.busy || !selected || this.state.selected === this.state.slots.length - 1;
      const unavailableSelection = !currentBase?.available || this.designPricingActive() && !this.starterRecord() || this.state.slots.some(key => key && (!this.lookup.get(key)?.available || !this.designCharmReady(this.lookup.get(key))));
      const unavailableNative = this.usesBaseCatalog() && this.state.slots.some(key => key && (!this.lookup.get(key)?.available || !this.designCharmReady(this.lookup.get(key))));
      this.$('review').disabled = this.busy || !currentBase || !selectedCount || (this.usesBaseCatalog() ? unavailableNative : unavailableSelection);
      this.$('add').disabled = this.busy || !currentBase || !selectedCount || (this.usesBaseCatalog() ? unavailableNative || !this.purchaseBaseReady() : unavailableSelection) || Boolean(this.pendingBuild);
      this.$('add').textContent = this.busy ? this.t('adding') : this.t('add_complete_design');
      this.$('close-review').disabled = this.busy;
      this.$('continue').disabled = this.busy;
      if (this.$('necklace-fit-note')) this.$('necklace-fit-note').hidden = this.state.piece !== 'necklace';
      this.drawChain();
    }
    previewChainGeometry() {
      const bracelet = this.state.piece === 'bracelet';
      const base = this.base();
      if (this.usesBaseCatalog()) {
        const code = base?.code || (bracelet ? 'A1' : this.state.piece === 'collar' ? 'C1' : 'N1');
        const profile = {
          A1: { step: 32, linkLength: 40, linkHeight: 22, stroke: 1.9, linkCount: 26, faces: [1, .92, .78, .96, .9, 1, .68, .91], clasp: 'lobster-extender', claspSize: 44, extenderCount: 7, extenderLength: 140, fixedHeartWidth: calibratedCharmVisuals['puffy-solid-heart-pendant'] * charmPreviewReferenceWidth },
          A2: { step: 35, linkLength: 43, linkHeight: 25, stroke: 3, linkCount: 24, faces: [.95, .86, 1, .92, .7, .96, .9], clasp: 'round', claspSize: 62 },
          N1: { step: 14, linkLength: 19, linkHeight: 10, stroke: .9, linkCount: 56, faces: [1, .86, .76, .94, .9, .65, .92], clasp: 'lobster-extender', claspSize: 21, extenderCount: 10, extenderLength: 143 },
          N2: { step: 16, linkLength: 22, linkHeight: 14, stroke: 1.2, linkCount: 54, faces: [1, .91, .85, .72, .95, .88], clasp: 'round', claspSize: 24 },
          N3: { step: 8.5, linkLength: 13, linkHeight: 9.5, stroke: 1.1, linkCount: 94, faces: [.93, .8, .95, .7, .9, .83], clasp: 'lobster-extender', claspSize: 22, extenderCount: 7, extenderLength: 65, faceted: true },
          N4: { step: 10, linkLength: 16, linkHeight: 10.5, stroke: 1.8, linkCount: 82, faces: [.88, .64, .9, .58, .83, .7], clasp: null },
          C1: { step: Infinity, linkLength: 0, linkHeight: 0, stroke: 2, clasp: null }
        }[code];
        const link = base?.linkStyle || 'oval-fine';
        const metal = { ...profile, sourceCode: code, hardwarePoint: bracelet ? { x: 270, y: 106 } : { x: 150, y: 65 } };
        if (bracelet) return { bracelet, height: 440, link, ...metal, fixedHeart: Boolean(base?.fixedHeart), center: { x: 270, y: 208 }, radius: { x: 169, y: 102 }, curve: 'M 101 208 A 169 102 0 1 1 439 208 A 169 102 0 1 1 101 208 Z' };
        if (this.state.piece === 'collar') return { bracelet: false, collar: true, height: 640, link: 'collar', ...metal, endInset: 10, usablePositions: 1, outerAnchorFractions: [], curve: 'M 150 110 C 103 170 102 290 146 344 C 178 384 223 397 270 399 C 317 397 362 384 394 344 C 438 290 437 170 390 110', attachmentCurve: 'M 146 344 C 178 384 223 397 270 399 C 317 397 362 384 394 344' };
        return { bracelet: false, height: 640, link, ...metal, endInset: 10, usablePositions: 7, outerAnchorFractions: [.255, .745], curve: 'M 150 65 C 126 170 120 260 145 305 C 180 365 222 408 270 408 C 318 408 360 365 395 305 C 420 260 414 170 390 65', attachmentCurve: 'M 145 305 C 180 365 222 408 270 408 C 318 408 360 365 395 305' };
      }
      const link = base?.linkStyle || 'paperclip';
      const metal = { step: link === 'rolo' ? 4.2 : 16, linkLength: link === 'rolo' ? 5 : 20, linkHeight: link === 'rolo' ? 3 : 8, stroke: link === 'rolo' ? 1.05 : 1.9 };
      if (bracelet) return {
        bracelet, height: 440, link, ...metal, center: { x: 270, y: 208 }, radius: { x: 169, y: 102 },
        curve: 'M 101 208 A 169 102 0 1 1 439 208 A 169 102 0 1 1 101 208 Z'
      };
      const long = base?.handle === 'classic-rolo-chain-necklace' || /\b50\s*cm\b/i.test(base?.caption || '');
      return {
        bracelet, height: 640, link, ...metal, endInset: 10, usablePositions: 7, outerAnchorFractions: [.255, .745],
        curve: long ? 'M 150 65 C 123 180 105 290 132 331 C 172 391 230 421 270 448 C 310 421 368 391 408 331 C 435 290 417 180 390 65' : 'M 150 65 C 126 170 120 260 145 305 C 180 357 235 385 270 408 C 305 385 360 357 395 305 C 420 260 414 170 390 65',
        attachmentCurve: long ? 'M 132 331 C 172 391 230 421 270 448 C 310 421 368 391 408 331' : 'M 145 305 C 180 357 235 385 270 408 C 305 385 360 357 395 305'
      };
    }
    previewCharmMetrics(product, geometry) {
      const imageWidth = Number(product.imageWidth) > 0 ? Number(product.imageWidth) : 1024;
      const imageHeight = Number(product.imageHeight) > 0 ? Number(product.imageHeight) : 1024;
      let crop = String(product.crop || '').trim().split(/\s+/).map(Number);
      if (crop.length !== 4 || !crop.every(Number.isFinite) || crop[2] <= 0 || crop[3] <= 0) crop = [0, 0, imageWidth, imageHeight];
      const estimatedWidth = Number(product.previewWidth) > 0 ? Number(product.previewWidth) : 44;
      const ratio = calibratedCharmVisuals[product.handle];
      const naturalWidth = ratio ? ratio * charmPreviewReferenceWidth : estimatedWidth;
      const naturalHeight = naturalWidth * crop[3] / crop[2];
      const fit = ratio ? 1 : Math.min(1, 48 / naturalWidth, 65 / naturalHeight);
      const width = naturalWidth * fit;
      const height = naturalHeight * fit;
      const reference = charmBailAnchors[product.handle];
      const calibratedAnchor = reference && reference.crop === crop.join(' ') && reference.imageWidth === imageWidth && reference.imageHeight === imageHeight;
      return { width, height, crop: crop.join(' '), imageWidth, imageHeight, anchorX: calibratedAnchor ? reference.x : .5, anchorY: calibratedAnchor ? reference.y : .02 };
    }
    previewCharmLayout(path, geometry, fullPath = path) {
      const selected = this.state.slots.flatMap((key, index) => {
        const product = this.lookup.get(key);
        return product?.photo ? [{ product, index, metrics: this.previewCharmMetrics(product, geometry) }] : [];
      });
      if (!selected.length) return [];
      const length = geometry.bracelet ? 0 : path.getTotalLength();
      const samples = geometry.bracelet ? [] : Array.from({ length: 1201 }, (_, index) => path.getPointAtLength(length * index / 1200));
      const pointAtX = x => {
        let first = 0, last = samples.length - 1;
        while (last - first > 1) {
          const middle = Math.floor((first + last) / 2);
          if (samples[middle].x < x) first = middle; else last = middle;
        }
        const before = samples[first], after = samples[last];
        const relative = after.x === before.x ? 0 : Math.max(0, Math.min(1, (x - before.x) / (after.x - before.x)));
        return { x: before.x + (after.x - before.x) * relative, y: before.y + (after.y - before.y) * relative };
      };
      let fit = 1;
      const layout = scale => {
        const items = selected.map(item => ({ ...item, metrics: { ...item.metrics, width: item.metrics.width * scale, height: item.metrics.height * scale } }));
        const lowerItems = geometry.bracelet ? [] : items.filter(item => item.index < geometry.usablePositions);
        let offsets = [0];
        if (!geometry.bracelet) {
          for (let index = 1; index < lowerItems.length; index++) {
            const previous = lowerItems[index - 1], current = lowerItems[index];
            const emptyPositions = current.index - previous.index - 1;
            offsets.push(offsets[index - 1] + (previous.metrics.width + current.metrics.width) / 2 + 10 + emptyPositions * 32);
          }
        }
        const occupiedSpan = offsets[offsets.length - 1];
        const firstX = geometry.bracelet ? 0 : samples[0].x;
        const lastX = geometry.bracelet ? 0 : samples[samples.length - 1].x;
        const availableSpan = geometry.bracelet ? 0 : Math.max(0, lastX - firstX - 2 * geometry.endInset);
        const spanFit = !geometry.bracelet && occupiedSpan > availableSpan ? availableSpan / occupiedSpan : 1;
        return items.map(item => {
          let point, angle = 0;
          const clearance = 0;
          const outerEnd = !geometry.bracelet && item.index >= geometry.usablePositions;
          if (geometry.bracelet) {
            const theta = Math.PI / 2 + (item.index + (geometry.fixedHeart ? 1 : 0)) * Math.PI * 2 / (this.state.slots.length + (geometry.fixedHeart ? 1 : 0));
            point = { x: geometry.center.x + geometry.radius.x * Math.cos(theta), y: geometry.center.y + geometry.radius.y * Math.sin(theta) };
            const normalAngle = Math.atan2(Math.sin(theta) / geometry.radius.y, Math.cos(theta) / geometry.radius.x);
            angle = normalAngle * 180 / Math.PI - 90;
          } else if (outerEnd) {
            point = fullPath.getPointAtLength(fullPath.getTotalLength() * geometry.outerAnchorFractions[item.index - geometry.usablePositions]);
          } else {
            const ordinal = lowerItems.findIndex(candidate => candidate.index === item.index);
            const targetX = (firstX + lastX) / 2 + (offsets[ordinal] - occupiedSpan / 2) * spanFit;
            point = pointAtX(targetX);
          }
          const localX = -item.metrics.width * item.metrics.anchorX;
          const localY = clearance - item.metrics.height * item.metrics.anchorY;
          return { ...item, x: point.x + localX, y: point.y + localY, localX, localY, clearance, angle, anchor: point, fit: scale, spanFit, outerEnd, attachment: geometry.bracelet ? 'perimeter' : outerEnd ? 'outer-end' : 'lower-arc', layer: geometry.bracelet && point.y < geometry.center.y - 1 ? 'back' : 'front' };
        });
      };
      const corners = item => {
        const radians = item.angle * Math.PI / 180, cosine = Math.cos(radians), sine = Math.sin(radians);
        return [[item.localX, item.localY], [item.localX + item.metrics.width, item.localY], [item.localX + item.metrics.width, item.localY + item.metrics.height], [item.localX, item.localY + item.metrics.height]].map(([x, y]) => ({ x: item.anchor.x + x * cosine - y * sine, y: item.anchor.y + x * sine + y * cosine }));
      };
      const overlaps = (first, second) => {
        const polygons = [corners(first), corners(second)];
        for (const polygon of polygons) {
          for (let index = 0; index < polygon.length; index++) {
            const edge = { x: polygon[(index + 1) % polygon.length].x - polygon[index].x, y: polygon[(index + 1) % polygon.length].y - polygon[index].y };
            const projections = polygons.map(points => points.map(point => point.x * -edge.y + point.y * edge.x));
            if (Math.max(...projections[0]) <= Math.min(...projections[1]) || Math.max(...projections[1]) <= Math.min(...projections[0])) return false;
          }
        }
        return true;
      };
      let arranged = layout(fit);
      for (let attempt = 0; attempt < 40; attempt++) {
        const clipped = arranged.some(item => corners(item).some(point => point.x < 12 || point.x > 528 || point.y < 12 || point.y > geometry.height - 12));
        const collision = arranged.some((item, index) => arranged.slice(index + 1).some(other => !item.outerEnd && !other.outerEnd && overlaps(item, other)));
        if (!clipped && !collision && arranged.every(item => item.spanFit >= .999)) break;
        fit *= .96;
        arranged = layout(fit);
      }
      return arranged;
    }
    previewCharmClip(product) {
      if (product.handle !== 'classic-teardrop-pearl-pendant' || Number(product.imageWidth) !== 1024 || Number(product.imageHeight) !== 1024) return null;
      try {
        return new URL(product.photo, location.href).pathname.endsWith('/1775791561553.jpg') ? pearlPreviewSilhouette : null;
      } catch (_) { return null; }
    }
    previewPhotoFilter(id) {
      // Only neutral near-white pixels (all sRGB channels 252–255) become transparent.
      const threshold = [...Array(63).fill(0), 1].join(' ');
      return `<filter id="${this.safe(id)}" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB"><feComponentTransfer in="SourceGraphic" result="white-channels">${['R', 'G', 'B'].map(channel => `<feFunc${channel} type="discrete" tableValues="${threshold}"/>`).join('')}</feComponentTransfer><feColorMatrix in="white-channels" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 -1 -1 -1 0 3" result="photo-mask"/><feComposite in="SourceGraphic" in2="photo-mask" operator="in"/></filter>`;
    }
    previewBaseLink(geometry, gradient, index, transform) {
      const face = geometry.faces[index % geometry.faces.length];
      const rx = geometry.linkLength / 2, ry = geometry.linkHeight * face / 2;
      const innerX = rx - geometry.stroke, innerY = Math.max(.65, ry - geometry.stroke);
      const oval = (x, y) => `M -${x} 0 C -${x} -${y * .63} -${x * .57} -${y} 0 -${y} C ${x * .57} -${y} ${x} -${y * .63} ${x} 0 C ${x} ${y * .63} ${x * .57} ${y} 0 ${y} C -${x * .57} ${y} -${x} ${y * .63} -${x} 0 Z`;
      const facets = geometry.faceted ? [-.55, -.1, .35].map(offset => `<path d="M ${rx * offset} -${ry * .92} l ${rx * .17} ${geometry.stroke * .7}" stroke="#f3eddf" stroke-width=".45" opacity=".85"/>`).join('') : '';
      return `<g data-preview-link="${face < .75 ? 'turned' : 'face'}" data-base-link="${geometry.sourceCode}" transform="${transform}"><path d="${oval(rx, ry)} ${oval(innerX, innerY)}" fill="url(#${gradient})" fill-rule="evenodd"/><path d="M -${rx * .65} -${ry * .62} Q -${rx * .05} -${ry * .98} ${rx * .56} -${ry * .75}" fill="none" stroke="#f5efdf" stroke-width="${Math.min(.95, geometry.stroke * .3)}" stroke-linecap="round"/><path d="M -${rx * .5} ${ry * .86} Q ${rx * .15} ${ry * 1.02} ${rx * .63} ${ry * .57}" fill="none" stroke="#827158" stroke-width="${geometry.stroke * .22}" opacity=".7" stroke-linecap="round"/>${facets}</g>`;
    }
    previewBaseHardware(geometry, gradient) {
      if (!geometry.clasp) return '';
      const { x, y } = geometry.hardwarePoint, size = geometry.claspSize;
      const round = geometry.clasp === 'round';
      const body = round ? `<circle r="${size / 2}" fill="none" stroke="url(#${gradient})" stroke-width="${size * .09}"/><path d="M ${size * .12} -${size * .46} A ${size * .475} ${size * .475} 0 0 1 ${size * .44} -${size * .17}" fill="none" stroke="#f5efdf" stroke-width="${size * .035}"/><path d="M ${size * .28} -${size * .35} l ${size * .16} -${size * .13}" stroke="#a39378" stroke-width="${size * .07}" stroke-linecap="round"/>` : `<g transform="scale(${size / 40})"><path d="M -19 -1 C -18 -12 -7 -16 5 -13 C 16 -11 22 -3 18 6 C 15 14 2 16 -11 12 C -18 10 -22 4 -19 -1 Z M -12 -1 C -13 5 -8 8 -2 8 C 7 8 13 4 12 -2 C 11 -7 2 -9 -6 -6 C -10 -5 -12 -3 -12 -1 Z" fill="url(#${gradient})" fill-rule="evenodd"/><path d="M -14 -5 C -9 -11 3 -12 11 -7" fill="none" stroke="#f5efdf" stroke-width="1.15" stroke-linecap="round"/><path d="M 16 -5 L 21 -8 L 23 -3 L 18 1" fill="none" stroke="#a39378" stroke-width="2.2" stroke-linecap="round"/></g>`;
      const joins = geometry.bracelet ? [-1, 1].map(side => `<ellipse cx="${side * size * .56}" cy="0" rx="${size * .12}" ry="${size * .085}" fill="none" stroke="url(#${gradient})" stroke-width="${Math.max(.9, geometry.stroke * .65)}"/>`).join('') : `<ellipse cx="0" cy="${size * .47}" rx="${Math.max(2.7, size * .14)}" ry="${Math.max(3, size * .17)}" fill="none" stroke="url(#${gradient})" stroke-width=".85"/>`;
      let extender = '';
      if (geometry.extenderCount) {
        const length = geometry.extenderLength, dx = geometry.bracelet ? -.85 : -.6, dy = geometry.bracelet ? -.45 : -.29;
        const pitch = length / geometry.extenderCount, angle = Math.atan2(dy, dx) * 180 / Math.PI;
        extender = Array.from({ length: geometry.extenderCount }, (_, index) => {
          const distance = (index + .5) * pitch;
          return `<ellipse data-preview-extender="${index + 1}" cx="${-size * .55 + distance * dx}" cy="${distance * dy}" rx="${pitch * .53}" ry="${geometry.bracelet ? 3.3 : 2.1}" transform="rotate(${angle} ${-size * .55 + distance * dx} ${distance * dy})" fill="none" stroke="url(#${gradient})" stroke-width="${geometry.bracelet ? .9 : .65}"/>`;
        }).join('') + `<ellipse cx="${-size * .55 + length * dx}" cy="${length * dy}" rx="3" ry="2" fill="url(#${gradient})"/>`;
      }
      return `<g data-preview-clasp="${geometry.clasp}" data-base-hardware="${geometry.sourceCode}" transform="translate(${x} ${y})">${extender}${body}${joins}</g>`;
    }
    drawChain() {
      const geometry = this.previewChainGeometry();
      const svg = this.$('jewelry');
      const gradient = `chic-metal-${this.config.sectionId}`;
      const photoFilter = this.usesBaseCatalog() ? `chic-photo-white-${this.config.sectionId}` : null;
      svg.setAttribute('viewBox', geometry.bracelet ? '0 0 540 440' : '60 215 420 320');
      svg.setAttribute('aria-label', this.t('preview_label', { piece: this.t(this.state.piece), count: this.state.slots.filter(Boolean).length }));
      svg.setAttribute('data-preview-piece', this.state.piece);
      svg.setAttribute('data-preview-view', geometry.bracelet ? geometry.sourceCode ? 'selected-base' : 'slight-overhead' : 'charm-closeup');
      svg.setAttribute('data-base-code', this.base()?.code || '');
      const palette = geometry.sourceCode ? ['#887254', '#d2c4a3', '#f6f0dd', '#b4a385', '#978360'] : ['#97723f', '#f1d391', '#b18a4b', '#ead29e', '#97723f'];
      svg.innerHTML = `<defs><linearGradient id="${gradient}" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="${palette[0]}"/><stop offset=".27" stop-color="${palette[1]}"/><stop offset=".54" stop-color="${palette[2]}"/><stop offset=".76" stop-color="${palette[3]}"/><stop offset="1" stop-color="${palette[4]}"/></linearGradient>${photoFilter ? this.previewPhotoFilter(photoFilter) : ''}</defs>${geometry.attachmentCurve ? `<path data-attachment d="${geometry.attachmentCurve}" fill="none" visibility="hidden" aria-hidden="true"/>` : ''}<g data-charms-back></g><path data-chain d="${geometry.curve}" fill="none" stroke="${geometry.collar ? `url(#${gradient})` : geometry.sourceCode ? 'none' : '#be9f66'}" stroke-width="${geometry.collar ? geometry.stroke : geometry.link === 'rolo' ? .7 : 1}"/><g data-links></g><g data-hardware></g><g data-charms></g>`;
      const path = svg.querySelector('[data-chain]');
      const length = path.getTotalLength();
      let links = '';
      const linkStep = geometry.linkCount ? length / geometry.linkCount : geometry.step;
      for (let distance = 0, index = 0; distance < length && (!geometry.linkCount || index < geometry.linkCount); distance += linkStep, index++) {
        if (geometry.collar) continue;
        const point = path.getPointAtLength(distance);
        const next = path.getPointAtLength(Math.min(distance + 1, length));
        const angle = Math.atan2(next.y - point.y, next.x - point.x) * 180 / Math.PI;
        const transform = `translate(${point.x} ${point.y}) rotate(${angle})`;
        if (geometry.sourceCode) {
          if (geometry.clasp && Math.hypot(point.x - geometry.hardwarePoint.x, point.y - geometry.hardwarePoint.y) < geometry.claspSize * .55) continue;
          links += this.previewBaseLink(geometry, gradient, index, transform);
        } else if (geometry.link === 'paperclip') {
          links += `<g transform="${transform}"><rect x="-${geometry.linkLength / 2}" y="-${geometry.linkHeight / 2}" width="${geometry.linkLength}" height="${geometry.linkHeight}" rx="${geometry.linkHeight / 2}" fill="none" stroke="url(#${gradient})" stroke-width="${geometry.stroke}"/><rect x="-${geometry.linkLength / 2 - 1}" y="-${geometry.linkHeight / 2 - 1}" width="${geometry.linkLength - 2}" height="${geometry.linkHeight - 2}" rx="${geometry.linkHeight / 2 - 1}" fill="none" stroke="#f6e6bf" stroke-width=".6"/></g>`;
        } else if (String(geometry.link).startsWith('oval-')) {
          const edge = Math.round(distance / geometry.step) % 2 === 1;
          const ry = (edge ? geometry.linkHeight * .36 : geometry.linkHeight) / 2;
          links += `<g data-preview-link="${edge ? 'edge' : 'face'}" transform="${transform}"><ellipse cx="0" cy="0" rx="${geometry.linkLength / 2}" ry="${ry}" fill="none" stroke="url(#${gradient})" stroke-width="${geometry.stroke}"/><path d="M -${geometry.linkLength * .32} -${ry * .75} Q 0 -${ry * 1.1} ${geometry.linkLength * .25} -${ry * .85}" fill="none" stroke="#f6e6bf" stroke-width=".55" stroke-linecap="round"/></g>`;
        } else {
          const rx = geometry.linkLength / 2;
          const ry = geometry.linkHeight / 2;
          links += `<g transform="${transform}"><ellipse cx="0" cy="0" rx="${rx}" ry="${ry}" fill="none" stroke="url(#${gradient})" stroke-width="${geometry.stroke}"/><ellipse cx="0" cy="-.3" rx="${Math.max(.5, rx - .7)}" ry="${Math.max(.4, ry - .7)}" fill="none" stroke="#f6e6bf" stroke-width="${geometry.bracelet ? .7 : .35}"/></g>`;
        }
      }
      svg.querySelector('[data-links]').innerHTML = links;
      if (geometry.sourceCode && svg.querySelector('[data-hardware]')) {
        svg.querySelector('[data-hardware]').innerHTML = this.previewBaseHardware(geometry, gradient);
      } else if (geometry.clasp && svg.querySelector('[data-hardware]')) {
        const x = geometry.bracelet ? 270 : 150, y = geometry.bracelet ? 106 : geometry.collar ? 110 : 65;
        const round = geometry.clasp === 'round';
        svg.querySelector('[data-hardware]').innerHTML = `<g data-preview-clasp="${geometry.clasp}" transform="translate(${x} ${y})"><ellipse cx="0" cy="0" rx="${round ? 10 : 8}" ry="${round ? 10 : 5}" fill="#faf7f0" stroke="url(#${gradient})" stroke-width="${round ? 2.7 : 2}"/>${round ? '<path d="M 6 -7 L 11 -11" stroke="#b18a4b" stroke-width="2" stroke-linecap="round"/>' : '<path d="M -2 -5 Q 1 -11 6 -8 L 9 -3" fill="none" stroke="#b18a4b" stroke-width="1.5"/>'}${geometry.clasp.includes('extender') ? Array.from({ length: 5 }, (_, index) => `<ellipse cx="${-13 - index * 6}" cy="${-2 - index * 3}" rx="4" ry="2.5" transform="rotate(27 ${-13 - index * 6} ${-2 - index * 3})" fill="none" stroke="url(#${gradient})" stroke-width="1.1"/>`).join('') : ''}</g>`;
      }
      const charms = this.previewCharmLayout(svg.querySelector('[data-attachment]') || path, geometry, path);
      const charmMarkup = ({ product, index, metrics, localX, localY, clearance, angle, anchor, fit, layer, outerEnd, attachment }) => {
        const silhouette = photoFilter ? this.previewCharmClip(product) : null;
        const clipId = `chic-pearl-${this.config.sectionId}-${index}`;
        const clip = silhouette ? `<defs><clipPath id="${this.safe(clipId)}" clipPathUnits="userSpaceOnUse">${silhouette.map(outline => `<path d="${outline}" clip-rule="evenodd" fill-rule="evenodd"/>`).join('')}</clipPath></defs>` : '';
        const treatment = silhouette ? ` clip-path="url(#${this.safe(clipId)})"` : photoFilter ? ` filter="url(#${this.safe(photoFilter)})"` : '';
        return `<g data-preview-slot="${index}" data-position="${index + 1}" data-variant-id="${this.safe(product.variantId)}" data-preview-layer="${layer}" data-preview-angle="${angle}" data-preview-scale="${fit}" data-preview-anchor-x="${anchor.x}" data-preview-anchor-y="${anchor.y}" data-preview-clearance="${clearance}" data-preview-attachment="${attachment}" data-preview-outer-end="${outerEnd}" transform="translate(${anchor.x} ${anchor.y}) rotate(${angle})"><svg x="${localX}" y="${localY}" width="${metrics.width}" height="${metrics.height}" viewBox="${metrics.crop}" style="mix-blend-mode:${photoFilter ? 'normal' : 'multiply'}" aria-hidden="true">${clip}<image href="${this.safe(product.photo)}" width="${metrics.imageWidth}" height="${metrics.imageHeight}"${treatment} /></svg></g>`;
      };
      svg.querySelector('[data-charms-back]').innerHTML = charms.filter(item => item.layer === 'back').map(charmMarkup).join('');
      const base = this.base();
      const heartPhoto = base?.fixedHeartPhoto || base?.photo;
      const heartCrop = String(base?.fixedHeartCrop || '').split(/\s+/).map(Number);
      const heartWidth = (geometry.fixedHeartWidth || calibratedCharmVisuals['puffy-solid-heart-pendant'] * charmPreviewReferenceWidth) * (charms[0]?.fit || 1);
      const heartHeight = heartCrop.length === 4 && heartCrop[2] > 0 ? heartWidth * heartCrop[3] / heartCrop[2] : 89;
      const heartClipId = `chic-fixed-heart-${this.config.sectionId}`;
      const heartSource = heartPhoto && Number(base?.fixedHeartImageWidth) === 1157 && Number(base?.fixedHeartImageHeight) === 1536 && new URL(heartPhoto, location.href).pathname.endsWith('/chic-base-bracelets-source-20261011.jpg');
      const heartX = geometry.fixedHeartWidth && heartSource ? geometry.center.x - (394 - heartCrop[0]) * heartWidth / heartCrop[2] : 238;
      const heartY = geometry.fixedHeartWidth && heartSource ? geometry.center.y + geometry.radius.y - (1078 - heartCrop[1]) * heartWidth / heartCrop[2] : 301;
      const heartClip = heartSource ? `<defs><clipPath id="${this.safe(heartClipId)}" clipPathUnits="userSpaceOnUse"><path d="M 388 1074 C 397 1068 407 1072 407 1082 C 408 1091 405 1098 400 1105 L 392 1105 C 387 1096 385 1082 388 1074 Z"/><path d="M 396 1104 C 383 1091 357 1092 344 1105 C 333 1116 332 1134 338 1150 C 348 1177 373 1196 398 1214 C 423 1194 450 1178 461 1151 C 468 1135 468 1117 457 1104 C 443 1090 414 1092 400 1104 Z"/></clipPath></defs>` : '';
      const fixedHeart = geometry.fixedHeart && heartPhoto && base?.fixedHeartCrop ? `<g data-fixed-heart="A1" aria-label="${this.safe(this.t('attached_heart_included'))}"><svg x="${heartX}" y="${heartY}" width="${heartWidth}" height="${heartHeight}" viewBox="${this.safe(base.fixedHeartCrop)}" style="mix-blend-mode:${heartSource ? 'normal' : 'multiply'}" aria-hidden="true">${heartClip}<image href="${this.safe(heartPhoto)}" width="${Number(base.fixedHeartImageWidth) || base.imageWidth}" height="${Number(base.fixedHeartImageHeight) || base.imageHeight}"${heartSource ? ` clip-path="url(#${this.safe(heartClipId)})"` : ''}/></svg></g>` : '';
      svg.querySelector('[data-charms]').innerHTML = fixedHeart + charms.filter(item => item.layer === 'front').map(charmMarkup).join('');
      if (!geometry.bracelet) {
        let left = 60, top = 215, right = 480, bottom = 535;
        for (const item of charms) {
          const radians = item.angle * Math.PI / 180, cosine = Math.cos(radians), sine = Math.sin(radians);
          for (const [x, y] of [[item.localX, item.localY], [item.localX + item.metrics.width, item.localY], [item.localX + item.metrics.width, item.localY + item.metrics.height], [item.localX, item.localY + item.metrics.height]]) {
            const sceneX = item.anchor.x + x * cosine - y * sine;
            const sceneY = item.anchor.y + x * sine + y * cosine;
            left = Math.min(left, sceneX - 16); top = Math.min(top, sceneY - 16);
            right = Math.max(right, sceneX + 16); bottom = Math.max(bottom, sceneY + 16);
          }
        }
        const width = right - left, height = bottom - top;
        svg.setAttribute('viewBox', `${left} ${top} ${width} ${height}`);
        svg.style.aspectRatio = `${width} / ${height}`;
      } else svg.style.removeProperty('aspect-ratio');
    }
    onClick(event) {
      const target = event.target.closest('button');
      if (!target || target.disabled || this.busy) return;
      if (target.dataset.variantRetry) { this.querySelector(`[data-option-handle="${target.dataset.variantRetry}"]`)?.dispatchEvent(new Event('change', { bubbles: true })); return; }
      if (target.dataset.role === 'catalog-more') { this.loadCatalog(Boolean(this.searchTerm)); return; }
      if (target.dataset.piece) {
        if (target.dataset.piece === this.state.piece) return;
        this.persist();
        const piece = target.dataset.piece;
        this.state = this.normalize(this.saved[piece], piece) || { piece, base: '', slots: Array(this.capacity(piece)).fill(null), selected: 0 };
        this.persist();
        this.render();
        return;
      }
      if (target.dataset.slot !== undefined) this.state.selected = Number(target.dataset.slot);
      if (target.dataset.product) { this.addCharm(target.dataset.product); return; }
      if (target.dataset.move) {
        const destination = this.state.selected + Number(target.dataset.move);
        if (destination < 0 || destination >= this.state.slots.length) return;
        [this.state.slots[this.state.selected], this.state.slots[destination]] = [this.state.slots[destination], this.state.slots[this.state.selected]];
        this.state.selected = destination;
      }
      if (target.dataset.role === 'remove') this.state.slots[this.state.selected] = null;
      if (target.dataset.role === 'review') { this.review(); this.$('review-dialog').showModal(); return; }
      if (['close-review', 'continue'].includes(target.dataset.role)) { this.$('review-dialog').close(); return; }
      if (target.dataset.role === 'add') { this.addDesign(); return; }
      this.designTouched = true;
      this.persist();
      this.render();
    }
    review() {
      const presentation = this.setPresentation(), includedIndex = presentation.included ? this.includedCharmIndex() : this.firstCharmIndex();
      this.$('review-base').textContent = this.base() && presentation.starterAmount !== null ? this.t('review_starter', { title: this.base().title, price: this.money(presentation.starterAmount) }) : this.t('choose_design');
      this.$('review-items').innerHTML = this.state.slots.map((key, index) => key ? `<li value="${index + 1}">${this.safe(this.lookup.get(key).title)}<span>${this.safe(index === includedIndex ? this.t(presentation.included ? 'review_included' : 'review_first_selected') : '+' + this.money(this.slotPrice(index)))}</span></li>` : '').join('');
      this.$('review-total').textContent = presentation.totalAmount === null ? '' : this.money(presentation.totalAmount);
      this.$('cart-error').textContent = '';
      this.render();
    }
    async request(path, body) {
      const routeRoot = this.config.routesRoot.replace(/\/?$/, '/');
      const response = await fetch(`${routeRoot}${path}`, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || this.t('cart_failed'));
      return payload;
    }
    async readCart() {
      const cart = await this.request('cart.js');
      if (!cart.items?.some(item => item.has_components)) return cart;
      const url = new URL(this.config.cartUrl, location.origin);
      url.searchParams.set('view', 'atelier-components');
      const composition = await this.getJSON(url.href);
      if (composition.currency !== cart.currency || !Array.isArray(composition.items) || composition.items.length !== cart.items.length) throw new Error(this.t('cart_uncertain'));
      for (const item of cart.items) {
        const record = composition.items.find(value => value.key === item.key && String(value.variantId) === String(item.variant_id || item.id) && value.quantity === item.quantity);
        if (!record || !Array.isArray(record.components)) throw new Error(this.t('cart_uncertain'));
        item.item_components = record.components;
      }
      return cart;
    }
    updateCartQuantities(cart) {
      this.cartQuantities = new Map();
      const originals = new Map(this.products.filter(product => product.nativeBuild?.variantId).map(product => [String(product.nativeBuild.variantId), String(product.variantId)]));
      for (const item of cart.items || []) {
        if (Array.isArray(item.item_components) && item.item_components.length) {
          for (const component of item.item_components) {
            const id = String(component.variantId || component.variant_id);
            this.cartQuantities.set(id, (this.cartQuantities.get(id) || 0) + component.quantity);
          }
          continue;
        }
        const id = item.has_components ? String(item.properties?._chic_original_variant || originals.get(String(item.variant_id || item.id)) || item.variant_id || item.id) : String(item.variant_id || item.id);
        this.cartQuantities.set(id, (this.cartQuantities.get(id) || 0) + item.quantity);
      }
    }
    async freshProducts() {
      if (this.usesBaseCatalog()) {
        if (!this.baseRecord() || this.baseRecord().status !== 'ACTIVE' || this.baseRecord().previewOnly || this.config.previewOnly === true) throw new Error(this.t('draft_checkout_disabled'));
        await this.refreshActiveBases();
        if (!this.purchaseBaseReady()) throw new Error(this.t('stock_changed', { title: this.base()?.title || '' }));
        const refreshed = new Map();
        for (const product of this.state.slots.map(key => this.lookup.get(key)).filter(Boolean)) {
          if (!refreshed.has(String(product.variantId))) refreshed.set(String(product.variantId), await this.getJSON(this.variantURL(product.handle, product.resolvedOptionIds, product.variantId)));
          const live = refreshed.get(String(product.variantId));
          if (String(live?.variantId) !== String(product.variantId) || live.handle !== product.handle || live.available !== true || !this.validBuildPrice(live)) throw new Error(this.t('design_pricing_unavailable'));
          const changed = this.designPrice(product) !== Math.min(live.price, live.buildPrice);
          Object.assign(product, { price: live.price, available: true, inventoryLimited: live.inventoryLimited === true, inventoryQuantity: live.inventoryQuantity, buildPrice: live.buildPrice, buildPriceCurrency: live.buildPriceCurrency, buildPriceSource: live.buildPriceSource, nativeBuild: live.nativeBuild, statementPendant: live.statementPendant === true });
          if (changed) throw new Error(this.t('price_changed'));
        }
        return false;
      }
      const selected = [this.base(), ...this.state.slots.map(key => this.lookup.get(key))].filter(Boolean);
      const needsBuildMetadata = product => this.designPricingActive() && product.kind === 'charm';
      const resolvedVariants = new Map();
      for (const product of selected.filter(product => product.deferred || needsBuildMetadata(product))) {
        if (!resolvedVariants.has(String(product.variantId))) resolvedVariants.set(String(product.variantId), this.getJSON(this.variantURL(product.handle, product.resolvedOptionIds, product.variantId)));
      }
      const handles = [...new Set(selected.filter(product => !product.deferred && !needsBuildMetadata(product)).map(product => product.handle))];
      const [refreshed, resolvedEntries] = await Promise.all([
        Promise.all(handles.map(handle => this.request(`products/${encodeURIComponent(handle)}.js`))),
        Promise.all([...resolvedVariants].map(async ([id, promise]) => [id, await promise]))
      ]);
      const resolved = new Map(resolvedEntries);
      let changedPrice = false;
      for (const product of selected) {
        let variant;
        let metadata;
        if (product.deferred || needsBuildMetadata(product)) {
          metadata = resolved.get(String(product.variantId));
          if (String(metadata?.variantId) === String(product.variantId)) variant = metadata;
        } else {
          const source = refreshed.find(value => value.handle === product.handle);
          variant = source?.variants.find(value => String(value.id) === String(product.variantId));
        }
        if (!variant || !variant.available) {
          product.available = false;
          throw new Error(this.t('stock_changed', { title: product.title }));
        }
        const previousDesignPrice = this.designPrice(product);
        product.price = variant.price;
        if (metadata) {
          Object.assign(product, { available: metadata.available === true, inventoryLimited: metadata.inventoryLimited === true, inventoryQuantity: metadata.inventoryQuantity, buildPrice: metadata.buildPrice ?? null, buildPriceCurrency: metadata.buildPriceCurrency ?? null, buildPriceSource: metadata.buildPriceSource ?? null, nativeBuild: metadata.nativeBuild ?? null });
        }
        if (previousDesignPrice !== this.designPrice(product)) changedPrice = true;
      }
      if (this.designPricingActive()) {
        await this.refreshStarterBundles();
        if (!this.starterStateReady(this.starterRecord())) throw new Error(this.t('design_pricing_unavailable'));
      }
      return changedPrice;
    }
    validateSelection() {
      if (this.usesBaseCatalog()) {
        if (!this.purchaseBaseReady()) throw new Error(this.t('draft_checkout_disabled'));
        if (!this.state.slots.some(Boolean) || this.state.slots.length !== this.baseRecord().capacity || this.state.piece !== this.baseRecord().piece) throw new Error(this.t('choose_design'));
        for (const product of [this.base(), ...this.state.slots.map(key => this.lookup.get(key))].filter(Boolean)) if (!product.available || (product.kind === 'charm' && !this.designCharmReady(product)) || (product.kind === 'charm' ? this.count(product.key) : 1) > this.remaining(product)) throw new Error(this.t('stock_changed', { title: product.title }));
        return;
      }
      if (!this.base() || !this.state.slots.some(Boolean)) throw new Error(this.t('choose_design'));
      if (this.designPricingActive() && !this.starterStateReady(this.starterRecord())) throw new Error(this.t('design_pricing_unavailable'));
      const required = new Map();
      for (const product of [this.base(), ...this.state.slots.map(key => this.lookup.get(key))].filter(Boolean)) {
        const id = String(product.variantId);
        required.set(id, (required.get(id) || 0) + 1);
      }
      for (const [id, quantity] of required) {
        const product = this.products.find(value => String(value.variantId) === id);
        if (!product.available || quantity > this.remaining(product)) throw new Error(this.t('stock_changed', { title: product.title }));
        if (!this.designCharmReady(product)) throw new Error(this.t('design_pricing_unavailable'));
      }
    }
    buildItems(buildId) {
      if (this.usesBaseCatalog()) {
        this.validateSelection();
        const base = this.base(), record = this.baseRecord();
        const common = { [this.t('cart_design')]: `CHIC-${buildId.slice(-8).toUpperCase()}`, [this.t('cart_type')]: this.t(this.state.piece), _chic_build_id: buildId, _chic_piece: this.state.piece };
        const positions = this.state.slots.map((key, index) => {
          const product = this.lookup.get(key);
          return { position: index + 1, variantId: key ? String(product.variantId) : null, ...(key ? { checkoutVariantId: String(product.nativeBuild.variantId), sourceHandle: product.handle, expectedPrice: this.designPrice(product) } : {}) };
        });
        const configuration = { version: 5, designId: buildId, pricingRule: 'base-plus-native', catalogId: this.config.baseCatalogId, type: this.state.piece, baseCode: record.code, baseVariantId: record.variantId, baseHandle: record.handle, basePrice: record.price, fixedHeart: Boolean(record.fixedHeart), capacity: record.capacity, positions };
        const arrangement = this.state.slots.map((key, index) => key ? `${index + 1}. ${this.lookup.get(key).title}` : null).filter(Boolean).join(' | ');
        return [{ id: base.variantId, quantity: 1, properties: { ...common, _chic_offer: 'atelier-base-native-usd-v1', _chic_component: 'base', _chic_position: 'base', _chic_base_catalog: configuration.catalogId, _chic_base_code: record.code, _chic_original_handle: record.handle, _chic_expected_price: String(record.price), _chic_configuration: JSON.stringify(configuration), [this.t('cart_arrangement')]: arrangement } }, ...positions.filter(position => position.variantId !== null).map(position => ({ id: position.checkoutVariantId, quantity: 1, properties: { ...common, _chic_offer: 'atelier-native-usd-v3', _chic_component: 'charm', _chic_position: String(position.position), _chic_original_variant: position.variantId, _chic_original_handle: position.sourceHandle, _chic_expected_price: String(position.expectedPrice), [this.t('cart_position_key')]: this.t('cart_position', { position: position.position, capacity: record.capacity }) } }))];
      }
      const base = this.base(), includedIndex = this.includedCharmIndex();
      const activePricing = this.designPricingActive();
      const starter = activePricing ? this.starterRecord() : null;
      if (activePricing && (!this.starterStateReady(starter) || this.state.slots.some(key => key && (!this.lookup.get(key)?.available || !this.designCharmReady(this.lookup.get(key)))))) throw new Error(this.t('design_pricing_unavailable'));
      const designCode = `CHIC-${buildId.slice(-8).toUpperCase()}`;
      const configuration = { version: activePricing ? 4 : 1, designId: buildId, type: this.state.piece, baseVariantId: String(base.variantId), ...(activePricing ? { starterVariantId: String(starter.variantId), includedPosition: includedIndex + 1, pricingRule: 'best-value' } : {}), capacity: this.state.slots.length, positions: this.state.slots.map((key, index) => {
        const product = this.lookup.get(key);
        return { position: index + 1, variantId: key ? String(product.variantId) : null, ...(activePricing && key ? { checkoutVariantId: String(index === includedIndex ? starter.variantId : product.nativeBuild.variantId), sourceHandle: product.handle, expectedPrice: this.slotPrice(index) } : {}) };
      }) };
      const common = { [this.t('cart_design')]: designCode, [this.t('cart_type')]: this.t(this.state.piece), _chic_build_id: buildId, _chic_piece: this.state.piece };
      const arrangement = this.state.slots.map((key, index) => key ? `${index + 1}. ${this.lookup.get(key).title}` : null).filter(Boolean).join(' | ');
      const included = this.lookup.get(this.state.slots[includedIndex]);
      const items = activePricing ? [{ id: starter.variantId, quantity: 1, properties: { ...common, _chic_offer: 'atelier-starter-usd-v4', _chic_expected_price: String(starter.price), _chic_original_base_variant: String(base.variantId), _chic_original_base_handle: base.handle, _chic_original_variant: String(included.variantId), _chic_original_handle: included.handle, [this.t('cart_arrangement')]: arrangement, [this.t('cart_position_key')]: this.t('cart_position', { position: includedIndex + 1, capacity: this.state.slots.length }), _chic_component: 'starter', _chic_position: String(includedIndex + 1), _chic_configuration: JSON.stringify(configuration) } }] : [{ id: base.variantId, quantity: 1, properties: { ...common, [this.t('cart_arrangement')]: arrangement, _chic_component: 'base', _chic_position: 'base', _chic_configuration: JSON.stringify(configuration) } }];
      this.state.slots.forEach((key, index) => {
        const product = this.lookup.get(key);
        if (key && (!activePricing || index !== includedIndex)) items.push({ id: activePricing ? product.nativeBuild.variantId : product.variantId, quantity: 1, properties: { ...common, ...(activePricing ? { _chic_offer: 'atelier-native-usd-v3', _chic_expected_price: String(this.designPrice(product)), _chic_original_variant: String(product.variantId), _chic_original_handle: product.handle } : {}), [this.t('cart_position_key')]: this.t('cart_position', { position: index + 1, capacity: this.state.slots.length }), _chic_component: 'charm', _chic_position: String(index + 1) } });
      });
      return items;
    }
    starterPlan(items, buildId) {
      const starters = items.filter(item => item.properties?._chic_component === 'starter');
      if (starters.length !== 1) return null;
      const starter = starters[0];
      let configuration;
      try { configuration = JSON.parse(starter.properties._chic_configuration); } catch (_) { return null; }
      const maximum = { necklace: 9, bracelet: 12 }[configuration?.type];
      if (![3, 4].includes(configuration?.version) || configuration.designId !== buildId || String(configuration.starterVariantId) !== String(starter.id) || String(configuration.baseVariantId) !== starter.properties._chic_original_base_variant || configuration.type !== starter.properties._chic_piece || !maximum || !Number.isInteger(configuration.capacity) || configuration.capacity < 1 || configuration.capacity > maximum || !Array.isArray(configuration.positions) || configuration.positions.length !== configuration.capacity) return null;
      if (!configuration.positions.every((position, index) => position?.position === index + 1 && (position.variantId === null || /^\d+$/.test(String(position.variantId))))) return null;
      const occupied = configuration.positions.filter(position => position.variantId !== null);
      const includedPosition = configuration.version === 4 ? configuration.includedPosition : configuration.firstPosition;
      const included = occupied.find(position => position.position === includedPosition);
      if (!included || starter.properties._chic_position !== String(includedPosition) || String(included.variantId) !== starter.properties._chic_original_variant || String(included.checkoutVariantId) !== String(starter.id) || included.sourceHandle !== starter.properties._chic_original_handle || included.expectedPrice !== 2000 || occupied.length !== items.length) return null;
      if (configuration.version === 4 ? configuration.pricingRule !== 'best-value' : occupied[0]?.position !== includedPosition) return null;
      if (!occupied.every(position => {
        const matches = items.filter(item => item.properties?._chic_position === String(position.position));
        if (matches.length !== 1) return false;
        const item = matches[0], properties = item.properties;
        if (item.quantity !== 1 || properties._chic_build_id !== buildId || properties._chic_piece !== configuration.type || String(item.id) !== String(position.checkoutVariantId) || String(position.variantId) !== properties._chic_original_variant || position.sourceHandle !== properties._chic_original_handle) return false;
        return position.position === includedPosition ? item === starter && properties._chic_offer === 'atelier-starter-usd-v4' : properties._chic_component === 'charm' && properties._chic_offer === 'atelier-native-usd-v3' && Number.isSafeInteger(position.expectedPrice) && position.expectedPrice >= 0 && position.expectedPrice <= 2500 && position.expectedPrice === Number(properties._chic_expected_price);
      })) return null;
      return { starter, configuration, included, occupied };
    }
    matchesStarter(line, expected) {
      const properties = expected.properties;
      if (line?.has_components !== true || line.properties?._chic_original_base_variant !== properties._chic_original_base_variant || line.properties?._chic_original_base_handle !== properties._chic_original_base_handle || line.properties?._chic_original_variant !== properties._chic_original_variant || line.properties?._chic_original_handle !== properties._chic_original_handle || line.item_components?.length !== 2) return false;
      const components = new Map(line.item_components.map(value => [String(value.variantId || value.variant_id), value.quantity]));
      return components.size === 2 && components.get(properties._chic_original_base_variant) === 1 && components.get(properties._chic_original_variant) === 1;
    }
    matchesBuild(cart, items, buildId) {
      const lines = (cart.items || []).filter(item => item.properties?._chic_build_id === buildId);
      if (lines.length !== items.length) return false;
      return items.every(expected => {
        const matching = lines.filter(line => String(line.variant_id || line.id) === String(expected.id) && line.properties?._chic_position === expected.properties._chic_position);
        return matching.length === 1 && matching[0].quantity === expected.quantity && (expected.properties._chic_offer !== 'atelier-base-native-usd-v1' || matching[0].has_components !== true && matching[0].properties?._chic_configuration === expected.properties._chic_configuration && matching[0].properties?._chic_base_catalog === expected.properties._chic_base_catalog && matching[0].properties?._chic_base_code === expected.properties._chic_base_code && matching[0].properties?._chic_original_handle === expected.properties._chic_original_handle && matching[0].properties?._chic_expected_price === expected.properties._chic_expected_price) && matching[0].properties?._chic_component === expected.properties._chic_component && (!expected.properties._chic_piece || matching[0].properties?._chic_piece === expected.properties._chic_piece) && (expected.properties._chic_offer !== 'atelier-starter-usd-v4' || this.matchesStarter(matching[0], expected) && matching[0].properties?._chic_configuration === expected.properties._chic_configuration) && (expected.properties._chic_offer !== 'atelier-native-usd-v3' || matching[0].has_components === true && matching[0].properties?._chic_original_variant === expected.properties._chic_original_variant && matching[0].properties?._chic_original_handle === expected.properties._chic_original_handle && matching[0].item_components?.length === 1 && String(matching[0].item_components[0].variantId || matching[0].item_components[0].variant_id) === expected.properties._chic_original_variant && matching[0].item_components[0].quantity === 1);
      });
    }
    pricingVerified(cart, items, buildId) {
      if (items.some(item => item.properties?._chic_offer === 'atelier-base-native-usd-v1')) return window.ChicAtelierCart?.verify?.(cart) === true;
      const offered = items.filter(item => item.properties?._chic_offer);
      if (!offered.length) return true;
      if (cart.currency !== 'USD') return false;
      if (items.some(item => item.properties?._chic_offer === 'atelier-starter-usd-v4')) {
        const starters = items.filter(item => item.properties?._chic_component === 'starter');
        if (starters.length !== 1 || offered.length !== items.length || starters[0].properties._chic_offer !== 'atelier-starter-usd-v4') return false;
        const starter = starters[0];
        if (!this.starterPlan(items, buildId)) return false;
        const record = this.starterMap.get(`${starter.properties._chic_original_base_variant}:${starter.properties._chic_original_variant}`);
        if (!record || String(record.variantId) !== String(starter.id) || record.baseHandle !== starter.properties._chic_original_base_handle || record.charmHandle !== starter.properties._chic_original_handle || record.price !== Number(starter.properties._chic_expected_price)) return false;
        return items.every(expected => {
          const properties = expected.properties, limit = Number(properties._chic_expected_price);
          if (properties._chic_component !== 'starter' && (properties._chic_component !== 'charm' || properties._chic_offer !== 'atelier-native-usd-v3' || !Number.isSafeInteger(limit) || limit < 0 || limit > 2500)) return false;
          const line = (cart.items || []).find(value => value.properties?._chic_build_id === buildId && value.properties?._chic_position === properties._chic_position && String(value.variant_id || value.id) === String(expected.id));
          return line?.properties?._chic_offer === properties._chic_offer && Number.isSafeInteger(limit) && line.original_price === limit && Number.isSafeInteger(line.final_price) && line.final_price >= 0 && line.final_price <= limit;
        });
      }
      const charmOffers = ['atelier-25-usd-v1', 'atelier-tiered-usd-v2', 'atelier-native-usd-v3'];
      const promised = items.filter(item => item.properties?._chic_component === 'charm');
      if (!promised.length || promised.some(item => !charmOffers.includes(item.properties?._chic_offer))) return false;
      const offer = promised[0].properties._chic_offer;
      if (promised.some(item => item.properties._chic_offer !== offer) || offered.filter(item => item.properties?._chic_component === 'base').length !== 1) return false;
      if (offered.some(item => item.properties?._chic_component === 'base' && item.properties._chic_offer !== `${offer}-base`)) return false;
      if (offered.some(item => item.properties?._chic_component === 'base' ? !charmOffers.map(offer => `${offer}-base`).includes(item.properties._chic_offer) : item.properties?._chic_component !== 'charm')) return false;
      for (const expected of offered.filter(item => item.properties?._chic_component === 'base')) {
        const line = (cart.items || []).find(item => item.properties?._chic_build_id === buildId && item.properties?._chic_component === 'base' && item.properties?._chic_position === 'base' && String(item.variant_id || item.id) === String(expected.id));
        if (line?.properties?._chic_offer !== expected.properties._chic_offer) return false;
      }
      return promised.every(expected => {
        const limit = Number(expected.properties._chic_expected_price);
        const line = (cart.items || []).find(item => item.properties?._chic_build_id === buildId && String(item.variant_id || item.id) === String(expected.id) && item.properties?._chic_position === expected.properties._chic_position && item.properties?._chic_component === 'charm' && item.properties?._chic_piece === expected.properties._chic_piece && item.properties?._chic_offer === expected.properties._chic_offer && item.quantity === expected.quantity);
        return Number.isSafeInteger(limit) && limit >= 0 && limit <= 2500 && Number.isSafeInteger(line?.final_price) && line.final_price >= 0 && line.final_price <= limit;
      });
    }
    verifiedBuild(cart, items, buildId) { return this.matchesBuild(cart, items, buildId) && this.pricingVerified(cart, items, buildId); }
    async verifiedCheckout(cart, items, buildId) {
      if (!this.verifiedBuild(cart, items, buildId)) return false;
      if (items.some(item => item.properties?._chic_offer === 'atelier-base-native-usd-v1')) return Boolean(window.ChicAtelierCart?.validate && await window.ChicAtelierCart.validate(cart));
      const starter = items.find(item => item.properties?._chic_offer === 'atelier-starter-usd-v4');
      const plan = starter ? this.starterPlan(items, buildId) : null;
      let includedProduct = null;
      if (starter) {
        await this.refreshStarterBundles();
        const properties = starter.properties;
        const record = this.starterMap.get(`${properties._chic_original_base_variant}:${properties._chic_original_variant}`);
        if (!this.starterStateReady(record) || String(record.variantId) !== String(starter.id)) return false;
        const [base, charm] = await Promise.all([
          this.getJSON(this.variantURL(properties._chic_original_base_handle, [], properties._chic_original_base_variant)),
          this.getJSON(this.variantURL(properties._chic_original_handle, [], properties._chic_original_variant))
        ]);
        if (String(base?.variantId) !== properties._chic_original_base_variant || base.handle !== properties._chic_original_base_handle || base.price !== record.base.price || base.available !== true || String(charm?.variantId) !== properties._chic_original_variant || charm.handle !== properties._chic_original_handle || charm.available !== true) return false;
        includedProduct = charm;
        if (plan.configuration.version === 4 && !this.validBuildPrice(charm)) return false;
      }
      const native = items.filter(item => item.properties?._chic_offer === 'atelier-native-usd-v3');
      const refreshed = new Map();
      for (const item of native) {
        const original = item.properties._chic_original_variant;
        if (!refreshed.has(original)) refreshed.set(original, this.getJSON(this.variantURL(item.properties._chic_original_handle, [], original)));
      }
      const records = new Map(await Promise.all([...refreshed].map(async ([id, promise]) => [id, await promise])));
      if (!native.every(item => {
        const product = records.get(item.properties._chic_original_variant);
        return String(product?.variantId) === item.properties._chic_original_variant && product.handle === item.properties._chic_original_handle && product.available === true && this.validBuildPrice(product) && String(product.nativeBuild.variantId) === String(item.id) && product.nativeBuild.price === Number(item.properties._chic_expected_price);
      })) return false;
      if (plan?.configuration.version === 4) {
        const candidates = plan.occupied.map(position => ({ product: position.position === plan.included.position ? includedProduct : records.get(String(position.variantId)), index: position.position - 1 }));
        if (!candidates.every(({ product }) => {
          const record = product && this.starterMap.get(`${plan.configuration.baseVariantId}:${product.variantId}`);
          return product?.available === true && this.validBuildPrice(product) && record?.charmHandle === product.handle && this.starterStateReady(record);
        })) return false;
        candidates.sort((left, right) => this.compareIncludedCharms(left, right));
        if (candidates[0]?.index + 1 !== plan.included.position) return false;
      }
      return true;
    }
    async rollbackBuild(cart, buildId) {
      let current = cart;
      const maximum = (cart.items || []).length + 1;
      for (let attempt = 0; attempt < maximum; attempt++) {
        const group = (current.items || []).filter(item => item.properties?._chic_build_id === buildId);
        const line = group.find(item => item.properties?._chic_component === 'base') || group[0];
        if (!line) return current;
        await this.request('cart/change.js', { id: line.key, quantity: 0 });
        current = await this.readCart();
      }
      throw new Error(this.t('cart_uncertain'));
    }
    async addDesign() {
      if (this.busy || this.pendingBuild) return;
      if (this.usesBaseCatalog() && !this.purchaseBaseReady()) { this.notify(this.t('draft_checkout_disabled'), true); return; }
      const unresolved = this.storedPending();
      if (unresolved) { await this.recoverPending(unresolved); return; }
      this.busy = true;
      this.render();
      this.$('cart-error').textContent = '';
      let buildId = null;
      let items = null;
      try {
        const cart = await this.readCart();
        this.updateCartQuantities(cart);
        const changedPrice = await this.freshProducts();
        this.validateSelection();
        if (changedPrice) { this.review(); throw new Error(this.t('price_changed')); }
        buildId = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        items = this.buildItems(buildId);
        this.rememberPending(buildId, items);
        let addFailure = null;
        try { await this.request('cart/add.js', { items }); } catch (error) { addFailure = error; }
        const reconciled = await this.readCart();
        if (await this.verifiedCheckout(reconciled, items, buildId)) {
          this.forgetPending(buildId);
          this.persist();
          this.notify(this.t('added_cart'));
          this.$('cart-link').classList.remove('is-hidden');
          location.assign(this.config.cartUrl);
          return;
        }
        const pricingUnavailable = this.matchesBuild(reconciled, items, buildId) && !this.pricingVerified(reconciled, items, buildId);
        const rolledBack = await this.rollbackBuild(reconciled, buildId);
        this.updateCartQuantities(rolledBack);
        this.forgetPending(buildId);
        this.pendingBuild = null;
        throw new Error(pricingUnavailable ? this.t('design_pricing_unavailable') : addFailure?.message || this.t('cart_failed'));
      } catch (error) {
        if (buildId && this.pendingBuild) {
          try {
            const cart = await this.readCart();
            if (await this.verifiedCheckout(cart, items, buildId)) {
              this.forgetPending(buildId);
              this.$('cart-link').classList.remove('is-hidden');
              location.assign(this.config.cartUrl);
              return;
            }
            if (this.matchesBuild(cart, items, buildId) && !this.pricingVerified(cart, items, buildId)) error = new Error(this.t('design_pricing_unavailable'));
            this.updateCartQuantities(await this.rollbackBuild(cart, buildId));
            this.forgetPending(buildId);
            this.pendingBuild = null;
          } catch (_) {
            this.notify(this.t('cart_uncertain'), true);
            this.$('cart-link').classList.remove('is-hidden');
            return;
          }
        }
        this.notify(error.message || this.t('cart_failed'), true);
      } finally {
        this.busy = false;
        this.render();
      }
    }
  }
  customElements.define('chic-charm-atelier', ChicCharmAtelier);
})();
